import styled, { keyframes } from "styled-components"

interface IIconLoading2Props {
  style?: React.CSSProperties,
}
const wind = keyframes`
0% {
  transform: rotate(0deg);
};
25% {
  transform: rotate(10deg);
};
75% {
  transform: rotate(-10deg);
};
`

const spin = keyframes`
0% {
  transform: rotate(0);
}
100% {
  transform: rotate(360deg);
}
`

const spinBack = keyframes`
0% {
  transform: rotate(0);
}
100% {
  transform: rotate(-360deg);
}
`

const floating = keyframes`
0% {
  opacity: 1;
    transform: translateY(0px);
};
50% {
    transform: translateY(-10px);
};
100% {
  opacity: 1;
    transform: translateY(0px);
};
`
const AnimateLeaf = styled.path`
animation: 1s Infinite  linear ${wind};
    animation-delay: 0s,1s;
`
const AnimateCharacter = styled.g`
animation: 1.5s Infinite  linear ${floating};
    animation-delay: 0s;
`

const Wheel1 = styled.path`
  animation: 1.9s Infinite  linear ${spin};
  animation-delay: 0s;
`

const Wheel2 = styled.path`
  animation: 2.3s Infinite  linear ${spinBack};
  animation-delay: 0s;
`

const IconLoading2 = ({ style }: IIconLoading2Props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 500 500"
    width={840}
    height={473}
    style={style || {}}
  >
    <g
      className="animable"
      style={{
        transformOrigin: "230.14px 268.265px",
      }}
    >
      <path
        d="M116.76 176.66a19 19 0 0 1 4.66-2l1-4.61 7.8-.14 1.12 4.58a18.78 18.78 0 0 1 4.73 1.86l3.94-2.58 5.61 5.42-2.44 4a19.28 19.28 0 0 1 2 4.67l4.61 1 .14 7.8-4.58 1.12a19.08 19.08 0 0 1-1.86 4.73l2.58 3.94-5.42 5.55-4-2.44a19.35 19.35 0 0 1-4.66 2l-1 4.62-7.79.13-1.12-4.57a19.41 19.41 0 0 1-4.74-1.87l-3.94 2.59-5.61-5.42 2.45-4a19 19 0 0 1-2-4.66l-4.61-1-.14-7.8 4.51-1.08a18.92 18.92 0 0 1 1.86-4.73l-2.59-3.94 5.42-5.61 4 2.44Zm4.16 10.39a8.36 8.36 0 1 0 11.83-.21 8.37 8.37 0 0 0-11.83.21Z"
        style={{
          fill: "#e0e0e0",
          transformOrigin: "126.71px 193.11px",
        }}
        className="animable"
      />
      <path
        d="M120.92 187.05a6.13 6.13 0 0 1 1.55-1.37 8.35 8.35 0 0 1 5.46-1.29 8.5 8.5 0 0 1 6.71 4.7 8 8 0 0 1 .76 2.35 8.19 8.19 0 0 1 0 2.57 8.55 8.55 0 0 1-7.06 7.32 8.28 8.28 0 0 1-2.58 0 8.11 8.11 0 0 1-2.37-.68 8.52 8.52 0 0 1-3.49-2.88 8.46 8.46 0 0 1-.34-9.16 6.37 6.37 0 0 1 1.31-1.6 18.53 18.53 0 0 0-1.15 1.7 8.33 8.33 0 0 0-.93 5.35 8.2 8.2 0 0 0 4.78 6.19 8.06 8.06 0 0 0 4.69.57A8.1 8.1 0 0 0 135 194a7.39 7.39 0 0 0 0-2.44 7.65 7.65 0 0 0-.71-2.23 8.16 8.16 0 0 0-6.35-4.55 8.35 8.35 0 0 0-5.32 1.11 18.62 18.62 0 0 0-1.7 1.16Z"
        style={{
          fill: "#e0e0e0",
          transformOrigin: "126.939px 192.885px",
        }}
        className="animable"
      />
      <path
        d="m116.76 176.66-.26-.14-.77-.44-3-1.8h.1l-5.39 5.64v-.15c.78 1.19 1.66 2.52 2.6 3.93V183.85a18.63 18.63 0 0 0-1.83 4.7v.09h-.1l-4.57 1.14.13-.17c.05 2.45.1 5.06.15 7.8l-.15-.19 4.62 1h.12v.12a19.4 19.4 0 0 0 2 4.61l.07.1-.07.11-2.43 4v-.26l5.62 5.41h-.28l3.94-2.59.12-.07.12.07a19 19 0 0 0 4.67 1.83h.14v.14c.35 1.43.74 3 1.13 4.58l-.24-.18 7.8-.09-.23.19c.3-1.46.63-3 1-4.62v-.14h.14a18.35 18.35 0 0 0 4.6-2l.13-.07.12.07 4 2.44h-.3c1.84-1.89 3.64-3.76 5.42-5.61v.3q-1.29-2-2.58-3.94l-.07-.12.06-.13a18.87 18.87 0 0 0 1.85-4.67v-.13h.14l4.58-1.12-.18.23c0-2.66-.09-5.26-.13-7.8l.18.21-4.62-1h-.12v-.12a18.94 18.94 0 0 0-2-4.62l-.06-.11.06-.1q1.26-2.07 2.45-4v.25l-5.6-5.43h.23l-4 2.58-.09.05-.09-.05a19.09 19.09 0 0 0-4.68-1.86h-.1v-.09c-.4-1.67-.76-3.17-1.11-4.58l.14.1-7.79.11.1-.09c-.4 1.84-.72 3.35-1 4.61a19.72 19.72 0 0 0-3.56 1.37l-.84.44-.28.14.26-.18c.18-.11.45-.27.82-.47a18.73 18.73 0 0 1 3.56-1.45l-.05.06c.25-1.26.56-2.78.93-4.62v-.09h.09l7.8-.17h.11v.11c.35 1.41.72 2.91 1.14 4.57l-.12-.11a19.49 19.49 0 0 1 4.78 1.86h-.18l3.93-2.59.13-.08.1.1 5.62 5.4.12.11-.08.14q-1.2 2-2.44 4v-.21a19.15 19.15 0 0 1 2.05 4.71l-.16-.15 4.62 1h.17v.17q.08 3.81.15 7.8v.18l-.18.05-4.54 1.17.17-.17a19.79 19.79 0 0 1-1.88 4.79v-.24l2.58 3.94.11.16-.14.13-5.41 5.62-.13.13-.17-.1-4-2.44h.25a19.1 19.1 0 0 1-4.72 2l.17-.18c-.33 1.59-.66 3.16-1 4.62v.18H131l-7.8.13h-.2v-.18c-.39-1.58-.77-3.14-1.12-4.58l.17.17a19.22 19.22 0 0 1-4.79-1.89h.24l-3.94 2.57-.15.1-.13-.12-5.6-5.42-.13-.12.09-.15 2.45-4v.21a19.27 19.27 0 0 1-2-4.72l.15.14-4.61-1h-.15v-.15c0-2.73-.09-5.34-.12-7.79v-.14h.13l4.58-1.11-.12.11a19.55 19.55 0 0 1 1.89-4.76v.15c-.92-1.43-1.79-2.76-2.57-3.95v-.09l.07-.07 5.45-5.58 3 1.85c.32.21.57.37.76.48Z"
        style={{
          fill: "#e0e0e0",
          transformOrigin: "126.74px 193.17px",
        }}
        className="animable"
      />
      <path
        d="M345.67 232a11.29 11.29 0 0 1 2.79-1.21L349 228l4.67-.09.67 2.74a11.84 11.84 0 0 1 2.83 1.12l2.36-1.55 3.36 3.24-1.47 2.42a11.32 11.32 0 0 1 1.22 2.79l2.76.57.08 4.67-2.74.67a11.41 11.41 0 0 1-1.11 2.83l1.54 2.36-3.17 3.4-2.41-1.46a11.29 11.29 0 0 1-2.79 1.21l-.58 2.76-4.66.09-.68-2.74a12 12 0 0 1-2.83-1.12l-2.36 1.55-3.36-3.25 1.47-2.41a11.32 11.32 0 0 1-1.22-2.79l-2.76-.57-.08-4.67 2.74-.67a11.41 11.41 0 0 1 1.11-2.83l-1.59-2.36 3.24-3.36 2.41 1.46Zm2.49 6.22a5 5 0 1 0 7.08-.13 5 5 0 0 0-7.08.14Z"
        style={{
          fill: "#f5f5f5",
          transformOrigin: "351.61px 241.84px",
        }}
        className="animable"
      />
      <path
        d="M348.16 238.23a3.75 3.75 0 0 1 .93-.82 5.06 5.06 0 0 1 5.49 0 5.14 5.14 0 0 1 1.8 2 4.75 4.75 0 0 1 .45 1.41 5 5 0 0 1 0 1.54 5.13 5.13 0 0 1-4.23 4.38 4.69 4.69 0 0 1-1.54 0 4.83 4.83 0 0 1-1.42-.4 5.2 5.2 0 0 1-2.09-1.73 5 5 0 0 1-.86-2.19 4.92 4.92 0 0 1 .66-3.29 3.61 3.61 0 0 1 .78-1s-.3.33-.69 1a5.08 5.08 0 0 0-.55 3.21 4.9 4.9 0 0 0 2.86 3.7 4.29 4.29 0 0 0 1.35.38 4.48 4.48 0 0 0 1.46 0 4.85 4.85 0 0 0 4-4.14 4.76 4.76 0 0 0 0-1.46 4.59 4.59 0 0 0-.42-1.33 4.87 4.87 0 0 0-1.69-1.94 4.95 4.95 0 0 0-5.3-.12c-.67.49-.97.83-.99.8Z"
        style={{
          fill: "#f5f5f5",
          transformOrigin: "351.762px 241.702px",
        }}
        className="animable"
      />
      <path
        d="M345.67 232s-.05 0-.15-.08l-.47-.27-1.81-1.07h.05l-3.22 3.42v-.09l1.55 2.35v.05a11.2 11.2 0 0 0-1.1 2.81v.06h-.06l-2.74.68.08-.1c0 1.47.06 3 .09 4.67l-.09-.11 2.77.57h.07v.07a11.39 11.39 0 0 0 1.2 2.76v.13l-1.46 2.41v-.16l3.37 3.24h-.17c.73-.49 1.54-1 2.36-1.55l.07-.05h.07a11.27 11.27 0 0 0 2.8 1.1h.08v.08l.67 2.74-.14-.1 4.67-.09-.14.11c.18-.87.38-1.81.58-2.76v-.08h.08a11.4 11.4 0 0 0 2.75-1.19l.08-.05.07.05 2.42 1.46h-.18c1.09-1.13 2.18-2.25 3.24-3.36v.18l-1.54-2.36-.05-.07v-.08a11.13 11.13 0 0 0 1.11-2.79v-.08h.08l2.74-.67-.11.13c0-1.59-.05-3.15-.07-4.67l.1.13-2.76-.58h-.08v-.08a11.18 11.18 0 0 0-1.19-2.76v-.13l1.46-2.41v.15l-3.35-3.25h.14l-2.36 1.54h-.06a11.09 11.09 0 0 0-2.81-1.11h-.05v-.05c-.24-1-.46-1.9-.67-2.75l.09.07-4.67.06h.06c-.24 1.1-.43 2-.59 2.76a12.41 12.41 0 0 0-2.14.82l-.5.27c-.11.06-.17.09-.17.08l.16-.1c.1-.07.27-.17.49-.29a11.56 11.56 0 0 1 2.13-.87c.15-.76.33-1.66.56-2.77v.03H349l4.66-.1h.07v.06c.21.85.43 1.75.68 2.74l-.07-.07a11.6 11.6 0 0 1 2.86 1.12h-.11l2.36-1.55h.07l.06.06 3.37 3.24.07.06-.05.09-1.4 2.35v-.13a11.7 11.7 0 0 1 1.23 2.82l-.1-.09 2.77.57h.1v.11c0 1.52.06 3.07.09 4.67v.11h-.11l-2.74.68.11-.11a11.74 11.74 0 0 1-1.13 2.87v-.14c.52.77 1 1.56 1.55 2.35l.06.1-.07.08-3.25 3.36-.08.08-.09-.06-2.42-1.46h.15a11.62 11.62 0 0 1-2.82 1.23l.1-.11c-.2 1-.4 1.89-.58 2.76v.11h-.11l-4.67.08h-.11v-.11l-.67-2.74.1.1A11.77 11.77 0 0 1 346 252h.14l-2.36 1.54-.09.06-.08-.08-3.35-3.24-.08-.07.06-.09 1.46-2.41v.13a11.37 11.37 0 0 1-1.22-2.83l.09.09-2.76-.58h-.09v-.09c0-1.64-.05-3.2-.07-4.67v-.08h.08l2.74-.66-.07.07a11.23 11.23 0 0 1 1.13-2.85v.08L340 234c1.32-1.36 2.42-2.49 3.26-3.34l1.78 1.11c.2.12.35.21.46.29Z"
        style={{
          fill: "#f5f5f5",
          transformOrigin: "351.655px 241.89px",
        }}
        className="animable"
      />
      <path
        d="M382.32 60.65a14.59 14.59 0 0 1 3.59-1.56l.74-3.56 6-.11.87 3.53a14.54 14.54 0 0 1 3.64 1.44l3-2 4.32 4.17-1.88 3.1a14.49 14.49 0 0 1 1.56 3.6l3.56.74.1 6-3.52.86a14.61 14.61 0 0 1-1.44 3.65l2 3-4.17 4.32-3.07-1.83a15 15 0 0 1-3.62 1.57l-.74 3.55-6 .11-.86-3.53a15 15 0 0 1-3.65-1.43l-3 2-4.32-4.18 1.88-3.1a14.59 14.59 0 0 1-1.56-3.59l-3.56-.75-.1-6 3.53-.87a14.36 14.36 0 0 1 1.38-3.65l-2-3 4.17-4.33 3.11 1.89Zm3.2 8a6.45 6.45 0 1 0 9.12-.16 6.46 6.46 0 0 0-9.12.16Z"
        style={{
          fill: "#f5f5f5",
          transformOrigin: "389.955px 73.325px",
        }}
        className="animable"
      />
      <path
        d="M385.52 68.65a5 5 0 0 1 1.2-1.05 6.44 6.44 0 0 1 4.21-1 6.56 6.56 0 0 1 5.17 3.62 6.51 6.51 0 0 1 .59 1.81 6.31 6.31 0 0 1 0 2 6.58 6.58 0 0 1-5.44 5.64 6.28 6.28 0 0 1-2 0 6.14 6.14 0 0 1-1.83-.52 6.59 6.59 0 0 1-2.64-2.15 6.54 6.54 0 0 1-.27-7.06 5.09 5.09 0 0 1 1-1.24s-.39.43-.88 1.31a6.45 6.45 0 0 0-.72 4.13 6.37 6.37 0 0 0 1.09 2.63 6.44 6.44 0 0 0 2.57 2.09 6.31 6.31 0 0 0 1.74.48 5.66 5.66 0 0 0 1.88 0 6.23 6.23 0 0 0 5.17-5.34 6.19 6.19 0 0 0-.57-3.6 6.33 6.33 0 0 0-4.89-3.51 6.42 6.42 0 0 0-4.1.86c-.87.5-1.25.94-1.28.9Z"
        style={{
          fill: "#f5f5f5",
          transformOrigin: "390.187px 73.1558px",
        }}
        className="animable"
      />
      <path
        d="m382.32 60.65-.2-.11-.6-.34-2.34-1.39h.08l-4.15 4.34V63c.61.91 1.28 1.93 2 3v.11a14.85 14.85 0 0 0-1.42 3.62v.07h-.07l-3.53.87.1-.13q.06 2.85.12 6l-.12-.14 3.56.74h.09v.09a14.48 14.48 0 0 0 1.55 3.56l.05.08-.05.08-1.88 3.11v-.21l4.33 4.17h-.21l3-2 .09-.06h.1a14.61 14.61 0 0 0 3.6 1.42h.1v.11l.87 3.53-.18-.14 6-.11-.18.15c.23-1.13.49-2.34.74-3.56v-.11h.11a14.25 14.25 0 0 0 3.54-1.54l.09-.06.1.06 3.1 1.88h-.22l4.17-4.32v.23l-2-3-.06-.09.05-.1a14.21 14.21 0 0 0 1.42-3.6v-.11h.1l3.53-.86-.13.17q-.06-3.08-.1-6l.13.16-3.55-.74h-.1v-.1a14.29 14.29 0 0 0-1.54-3.55l-.05-.09.05-.08 1.89-3.1v.19l-4.32-4.18h.18l-3 2h-.14a14.73 14.73 0 0 0-3.61-1.43h-.07v-.07c-.31-1.28-.59-2.44-.85-3.53l.1.08-6 .08.08-.06c-.3 1.41-.55 2.58-.76 3.55a15.41 15.41 0 0 0-2.75 1.06l-.65.34-.21.11.2-.14.63-.36A13.73 13.73 0 0 1 385.9 59c.2-1 .44-2.14.72-3.56v-.06h.07l6-.14h.09v.09c.27 1.09.56 2.24.87 3.52l-.08-.09a15.39 15.39 0 0 1 3.68 1.44h-.14l3-2 .1-.07.08.08 4.33 4.17.09.08-.07.11c-.6 1-1.23 2-1.87 3.11v-.17a15 15 0 0 1 1.58 3.63l-.12-.11 3.55.73h.14V70q0 2.92.11 6v.14h-.13l-3.53.87.13-.13a15.06 15.06 0 0 1-1.45 3.69v-.19c.66 1 1.32 2 2 3l.08.13-.11.1-4.16 4.39-.1.1-.13-.07-3.1-1.89h.19a15.63 15.63 0 0 1-3.64 1.58l.13-.14c-.25 1.22-.51 2.43-.74 3.55v.15h-.15l-6 .1h-.14v-.14c-.29-1.21-.59-2.42-.86-3.53l.13.14a15.11 15.11 0 0 1-3.69-1.46h.19l-3 2-.12.08-.1-.1-4.32-4.18-.09-.09.07-.11 1.89-3.1v.16a15.58 15.58 0 0 1-1.57-3.63l.12.1-3.56-.74h-.11v-.11c0-2.11-.07-4.12-.09-6v-.11h.11l3.53-.86-.09.09a14.88 14.88 0 0 1 1.46-3.67v.11l-2-3v-.06L375 63l4.2-4.3 2.29 1.43.59.37Z"
        style={{
          fill: "#f5f5f5",
          transformOrigin: "390.05px 73.31px",
        }}
        className="animable"
      />
      <path
        d="M284.22 87.28a11.52 11.52 0 0 1 2.8-1.21l.57-2.76 4.67-.09.67 2.74a11.84 11.84 0 0 1 2.83 1.12l2.36-1.55 3.36 3.24-1.48 2.42a11.68 11.68 0 0 1 1.23 2.81l2.76.57.08 4.67-2.74.67a11.41 11.41 0 0 1-1.11 2.83l1.55 2.36-3.25 3.36-2.41-1.46a11.29 11.29 0 0 1-2.79 1.21l-.57 2.76-4.67.09-.67-2.74a12.08 12.08 0 0 1-2.84-1.12l-2.35 1.55-3.36-3.24 1.46-2.42a11.29 11.29 0 0 1-1.21-2.79l-2.77-.57-.08-4.73 2.74-.67a11.06 11.06 0 0 1 1.12-2.83l-1.55-2.36 3.24-3.36 2.41 1.46Zm2.49 6.22a5 5 0 1 0 7.08-.13 5 5 0 0 0-7.08.13Z"
        style={{
          fill: "#f5f5f5",
          transformOrigin: "290.165px 97.14px",
        }}
        className="animable"
      />
      <path
        d="M286.71 93.5a3.7 3.7 0 0 1 .94-.82 5 5 0 0 1 5.48 0 5.14 5.14 0 0 1 1.8 2 4.75 4.75 0 0 1 .45 1.41 4.67 4.67 0 0 1 0 1.54 5.1 5.1 0 0 1-1.39 2.88 5.16 5.16 0 0 1-2.84 1.5 4.69 4.69 0 0 1-1.54 0 4.83 4.83 0 0 1-1.42-.4 5.17 5.17 0 0 1-2.08-1.73 5.07 5.07 0 0 1-.87-2.19 5 5 0 0 1 .66-3.29 3.61 3.61 0 0 1 .78-1s-.3.33-.69 1a5 5 0 0 0-.55 3.2 5 5 0 0 0 .86 2.08 4.75 4.75 0 0 0 2 1.62 4.37 4.37 0 0 0 1.35.38 4.48 4.48 0 0 0 1.46 0 4.82 4.82 0 0 0 4-4.14 4.21 4.21 0 0 0 0-1.46 4.31 4.31 0 0 0-.42-1.33 4.92 4.92 0 0 0-3.8-2.73 5 5 0 0 0-3.19.67c-.7.5-.96.84-.99.81Z"
        style={{
          fill: "#f5f5f5",
          transformOrigin: "290.316px 96.968px",
        }}
        className="animable"
      />
      <path
        d="M284.22 87.28s-.05 0-.15-.08l-.46-.27-1.82-1.07h.06l-3.23 3.38v-.09l1.56 2.35a11.59 11.59 0 0 0-1.1 2.81v.06H279l-2.74.68.07-.1c0 1.47.06 3 .1 4.67l-.09-.11 2.76.57h.07v.07a11.44 11.44 0 0 0 1.21 2.76v.13c-.46.75-1 1.57-1.46 2.41v-.16l3.36 3.24h-.17l2.36-1.55h.14a11.43 11.43 0 0 0 2.8 1.1h.08v.08l.67 2.74-.13-.1 4.66-.09-.13.11c.18-.87.37-1.81.57-2.76v-.08h.08a11.4 11.4 0 0 0 2.75-1.19H296.11l2.41 1.46h-.18q1.65-1.7 3.24-3.36v.18l-1.55-2.36-.05-.07.05-.07a11.73 11.73 0 0 0 1.1-2.8v-.08h.08l2.74-.67-.1.13c0-1.59-.05-3.15-.08-4.66l.1.12-2.76-.58h-.07v-.08a11.2 11.2 0 0 0-1.2-2.76v-.13l1.47-2.41v.15L298 85.61h.14l-2.36 1.54h-.11a11.18 11.18 0 0 0-2.8-1.11h-.06V86c-.24-1-.46-1.9-.66-2.75l.08.07-4.67.06.06-.05c-.23 1.1-.43 2-.59 2.76a12.76 12.76 0 0 0-2.14.82l-.5.27c-.11.06-.17.09-.17.08l.16-.1c.11-.07.27-.17.49-.29A11.56 11.56 0 0 1 287 86c.15-.76.33-1.66.56-2.77v-.05l4.67-.1h.06v.06c.21.85.43 1.75.68 2.74l-.07-.07a11.6 11.6 0 0 1 2.91 1.19h-.1l2.35-1.55h.07l.07.06 3.36 3.24.07.06-.05.09-1.46 2.41v-.13a11.7 11.7 0 0 1 1.23 2.82l-.09-.09 2.76.57h.1v.11c0 1.52.06 3.07.09 4.67v.11h-.1l-2.74.68.1-.1a11.44 11.44 0 0 1-1.13 2.86v-.14l1.54 2.35.07.1-.08.08-3.24 3.36-.08.08-.1-.06-2.45-1.48h.14a11.62 11.62 0 0 1-2.82 1.23l.1-.11c-.2 1-.39 1.89-.57 2.76v.11h-.11l-4.67.08H288v-.11l-.67-2.74.1.1a11.53 11.53 0 0 1-2.86-1.13h.14l-2.36 1.54-.09.06-.08-.08-3.35-3.24-.08-.07.06-.09 1.46-2.41v.13a11.76 11.76 0 0 1-1.22-2.83l.09.09-2.76-.58h-.09v-.09c0-1.64-.05-3.2-.07-4.67V95h.08l2.74-.66-.07.07A11.23 11.23 0 0 1 280 91.5v.08c-.56-.85-1.07-1.65-1.54-2.36 1.33-1.36 2.42-2.49 3.26-3.34l1.77 1.11c.2.12.35.21.46.29Z"
        style={{
          fill: "#f5f5f5",
          transformOrigin: "290.215px 97.125px",
        }}
        className="animable"
      />
      <path
        d="M70.34 169.6a11.29 11.29 0 0 1 2.79-1.21l.57-2.76 4.67-.08.67 2.74a11.41 11.41 0 0 1 2.83 1.11l2.36-1.55 3.36 3.25-1.46 2.41a11.29 11.29 0 0 1 1.21 2.79l2.76.57.08 4.67-2.74.67a11.41 11.41 0 0 1-1.11 2.79l1.55 2.36-3.25 3.36-2.41-1.46a11.29 11.29 0 0 1-2.79 1.21l-.57 2.77-4.67.08-.67-2.74a11.44 11.44 0 0 1-2.83-1.12l-2.36 1.55-3.33-3.2 1.46-2.42a11.29 11.29 0 0 1-1.21-2.79l-2.8-.6-.08-4.67 2.74-.67a11.44 11.44 0 0 1 1.12-2.83l-1.55-2.36 3.24-3.36 2.42 1.46Zm2.48 6.22a5 5 0 1 0 7.08-.12 5 5 0 0 0-7.08.12Z"
        style={{
          fill: "#f5f5f5",
          transformOrigin: "76.275px 179.435px",
        }}
        className="animable"
      />
      <path
        d="M72.82 175.82a4 4 0 0 1 .94-.82 5 5 0 0 1 5.48 0 5.14 5.14 0 0 1 1.8 2 4.75 4.75 0 0 1 .45 1.41 4.67 4.67 0 0 1 0 1.54 5.13 5.13 0 0 1-1.39 2.89 5.22 5.22 0 0 1-2.83 1.49 4.75 4.75 0 0 1-1.55 0 4.83 4.83 0 0 1-1.42-.4 5.13 5.13 0 0 1-3-3.92 5 5 0 0 1 .66-3.29 3.61 3.61 0 0 1 .78-1s-.3.33-.68 1a4.92 4.92 0 0 0 2.3 6.91 4.65 4.65 0 0 0 1.35.37 4.48 4.48 0 0 0 1.46 0 4.82 4.82 0 0 0 4-4.14 4.21 4.21 0 0 0 0-1.46 4.31 4.31 0 0 0-.42-1.33 4.92 4.92 0 0 0-3.8-2.73 5 5 0 0 0-3.18.67c-.63.5-.92.84-.95.81Z"
        style={{
          fill: "#f5f5f5",
          transformOrigin: "76.401px 179.288px",
        }}
        className="animable"
      />
      <path
        d="M70.34 169.6s-.06 0-.16-.08l-.46-.27-1.82-1.07h.1l-3.23 3.38v-.09l1.56 2.35v.05a11.18 11.18 0 0 0-1.09 2.81v.06l-2.74.68.08-.1c0 1.47.06 3 .09 4.67l-.09-.11 2.76.57h.07v.07a11.44 11.44 0 0 0 1.21 2.76v.13l-1.46 2.41v-.16l3.26 3.34h-.17l2.36-1.55h.14a11.59 11.59 0 0 0 2.8 1.1h.08v.08c.21.86.44 1.8.68 2.74l-.14-.1 4.66-.09-.13.12c.18-.88.37-1.82.57-2.77v-.08h.08a11.63 11.63 0 0 0 2.76-1.19l.07-.05.08.05 2.41 1.46h-.18l3.24-3.35v.17l-1.55-2.36v-.14a11.73 11.73 0 0 0 1.1-2.8v-.08h.08l2.74-.67-.1.13c0-1.59 0-3.15-.08-4.66l.11.12-2.77-.58h-.07v-.08a11.2 11.2 0 0 0-1.2-2.76v-.13l1.5-2.53v.15q-1.77-1.71-3.35-3.25h.13l-2.36 1.54h-.11a11.18 11.18 0 0 0-2.8-1.11h-.06v-.05l-.66-2.74.08.06-4.67.06.06-.05c-.23 1.1-.43 2-.59 2.76a11.34 11.34 0 0 0-2.13.83l-.51.26c-.11.06-.16.09-.16.08l.15-.1c.11-.07.27-.17.49-.29a11.68 11.68 0 0 1 2.13-.86c.15-.75.34-1.66.56-2.77v-.05l4.67-.1h.06v.07c.21.84.43 1.74.68 2.73l-.07-.07a11.6 11.6 0 0 1 2.86 1.12h-.1l2.35-1.55h.07l.07.06 3.39 3.27.07.07v.08l-1.46 2.41v-.13a11 11 0 0 1 1.23 2.82l-.09-.09 2.76.57h.1v.1c0 1.52.05 3.08.08 4.67v.11h-.1l-2.74.68.1-.1a11.44 11.44 0 0 1-1.13 2.86V185l1.51 2.33.06.09-.08.08-3.24 3.36-.08.08-.1-.06-2.41-1.46h.14a11.62 11.62 0 0 1-2.82 1.23l.1-.11c-.2 1-.39 1.89-.57 2.76v.12h-.11l-4.67.08h-.11v-.11l-.67-2.74.1.1a11.53 11.53 0 0 1-2.86-1.13h.14l-2.36 1.54-.09.06-.08-.08-3.35-3.24-.07-.07v-.09l1.46-2.41v.13a11.86 11.86 0 0 1-1.22-2.82l.09.08-2.76-.58h-.09V182c0-1.64-.05-3.2-.07-4.67v-.08h.08l2.74-.66-.07.07a11.77 11.77 0 0 1 1.13-2.85v.08l-1.54-2.36 3.26-3.34 1.77 1.11.46.29Z"
        style={{
          fill: "#f5f5f5",
          transformOrigin: "76.32px 179.435px",
        }}
        className="animable"
      />
      <path
        d="m104.35 317.52-2.12-8.66a36.36 36.36 0 0 1-9-3.53l-7.48 4.91-10.63-10.33 4.62-7.63a36.38 36.38 0 0 1-3.83-8.82l-8.76-1.83-.26-14.81 8.67-2.13a36.49 36.49 0 0 1 3.52-9l-4.9-7.48 10.29-10.66 7.63 4.63a36.21 36.21 0 0 1 8.82-3.83l1.82-8.76 14.81-.26 2.12 8.67a35.94 35.94 0 0 1 9 3.52l7.48-4.91L146.86 247l-4.62 7.63a36.12 36.12 0 0 1 3.83 8.83l8.76 1.82.26 14.81-8.67 2.13a36.33 36.33 0 0 1-3.52 9l4.9 7.48-10.29 10.66-7.63-4.63a36.63 36.63 0 0 1-8.82 3.84l-1.82 8.75Zm-11.08-12.26a36 36 0 0 0 9 3.53l2.13 8.66 14.75-.25 1.82-8.75a36 36 0 0 0 8.84-3.84l7.62 4.62 10.25-10.61-4.9-7.47a36.5 36.5 0 0 0 3.53-9L155 280l-.26-14.75-8.74-1.78a36.77 36.77 0 0 0-3.84-8.84l4.64-7.63-10.61-10.25-7.47 4.9a36 36 0 0 0-9-3.53l-2.13-8.66-14.75.26-1.84 8.69a36 36 0 0 0-8.84 3.84l-7.63-4.62-10.26 10.61 4.9 7.47a36.24 36.24 0 0 0-3.52 9L67 266.83l.26 14.75L76 283.4a36.94 36.94 0 0 0 3.84 8.84l-4.62 7.63 10.61 10.24Zm18.18-16.41A15.9 15.9 0 0 1 100 261.91a15.83 15.83 0 0 1 11.16-4.85h.29a15.89 15.89 0 0 1 .27 31.78Zm0-31.73a15.84 15.84 0 1 0 0 31.67h.29a15.84 15.84 0 0 0-.28-31.67Z"
        style={{
          fill: "#e0e0e0",
          transformOrigin: "110.99px 273.425px",
        }}
        className="animable"
      />
      <path
        d="M100 261.93a11.92 11.92 0 0 1 3-2.59 15.77 15.77 0 0 1 10.35-2.45 16.1 16.1 0 0 1 12.72 8.91 15.39 15.39 0 0 1 1.45 4.45 15.69 15.69 0 0 1 .09 4.89 16.19 16.19 0 0 1-13.4 13.86 15.11 15.11 0 0 1-4.88.09 15.43 15.43 0 0 1-4.51-1.29 16.32 16.32 0 0 1-6.6-5.46 16.09 16.09 0 0 1-2.75-7A15.84 15.84 0 0 1 97.55 265a12 12 0 0 1 2.49-3c.09.07-1 1-2.18 3.22a15.83 15.83 0 0 0-1.75 10.16 15.47 15.47 0 0 0 9.06 11.62 14.39 14.39 0 0 0 4.27 1.2 15 15 0 0 0 4.62-.1 15.36 15.36 0 0 0 12.66-13.1 15.47 15.47 0 0 0-1.4-8.85 15.49 15.49 0 0 0-12-8.64 15.84 15.84 0 0 0-10.09 2.11c-2.18 1.32-3.11 2.38-3.23 2.31Z"
        style={{
          fill: "#ebebeb",
          transformOrigin: "111.536px 273.019px",
        }}
        className="animable"
      />
      <path
        d="M92.16 242.23a4.83 4.83 0 0 1-.5-.26l-1.46-.85-5.76-3.4h.18L74.41 248.4v-.29l4.92 7.45.09.14-.08.14a36.26 36.26 0 0 0-3.47 8.92v.17h-.18l-8.69 2.2.25-.32c.09 4.65.19 9.6.29 14.79l-.28-.35 8.74 1.81h.22l.06.22a35.78 35.78 0 0 0 3.82 8.75l.12.2-.12.2-4.62 7.65-.07-.5 10.66 10.26-.53-.05 7.46-4.87.22-.14.23.13a36.36 36.36 0 0 0 8.86 3.48l.26.06.07.26c.66 2.72 1.39 5.69 2.13 8.68l-.44-.34 14.79-.26-.44.36c.58-2.77 1.2-5.75 1.82-8.76l.06-.27.26-.07a35.84 35.84 0 0 0 8.73-3.79l.24-.14.23.14 7.64 4.64-.56.07 10.27-10.64v.56l-4.89-7.48-.15-.22.13-.24a35.53 35.53 0 0 0 3.49-8.86l.07-.26.26-.06 8.68-2.12-.33.43c-.08-5.05-.17-10-.24-14.79l.33.4-8.72-1.84-.24-.05-.07-.24a35.92 35.92 0 0 0-3.79-8.75l-.12-.21.12-.2q2.38-3.93 4.65-7.63l.06.46L136 236.94h.43l-7.49 4.88-.16.11-.17-.1a35.9 35.9 0 0 0-8.89-3.52h-.18v-.17c-.76-3.16-1.45-6-2.1-8.69l.27.2-14.79.2.19-.17c-.75 3.49-1.36 6.36-1.87 8.74v.09h-.09a36.93 36.93 0 0 0-6.76 2.6l-1.59.83a3.61 3.61 0 0 1-.53.27 5.08 5.08 0 0 1 .49-.34c.34-.2.85-.52 1.56-.9a35.46 35.46 0 0 1 6.75-2.75l-.1.12c.48-2.4 1.06-5.27 1.76-8.77v-.16h.16l14.79-.33h.21l.05.21c.67 2.68 1.38 5.52 2.16 8.67l-.22-.21a36.24 36.24 0 0 1 9.06 3.53h-.33l7.39-4.88.23-.16.2.2 10.66 10.25.22.21-.16.26-4.62 7.65v-.41a36.06 36.06 0 0 1 3.9 8.94l-.31-.29 8.76 1.81.33.07v.33q.14 7.22.28 14.79v.35l-.33.08-8.68 2.13.32-.32a36.72 36.72 0 0 1-3.57 9.09v-.46l4.9 7.47.2.3-.25.26-10.27 10.64-.25.26-.31-.19-7.66-4.66h.46a36.85 36.85 0 0 1-9 3.88l.32-.34c-.62 3-1.24 6-1.82 8.75l-.07.35h-.37l-14.78.25H104l-.09-.35c-.73-3-1.45-6-2.12-8.68l.32.32a36.59 36.59 0 0 1-9.07-3.58h.44L86 310.54l-.28.18-.24-.23-10.61-10.29-.23-.22.16-.28 4.65-7.63v.4a36.58 36.58 0 0 1-3.87-8.94l.28.26-8.75-1.79-.28-.06v-.28c-.08-5.19-.16-10.13-.23-14.79v-.26l.25-.06 8.69-2.11-.22.22a36.31 36.31 0 0 1 3.59-9v.28c-1.76-2.7-3.4-5.23-4.87-7.5l-.1-.15.13-.13 10.33-10.59.08-.08.1.06 5.63 3.5 1.45.92a5.08 5.08 0 0 1 .5.26Z"
        style={{
          fill: "#ebebeb",
          transformOrigin: "111.045px 273.485px",
        }}
        className="animable"
      />
      <path
        d="M347.16 93a24.09 24.09 0 0 1 6.41 1l4.18-4.33 8.51 5.16-1.91 5.7a24.32 24.32 0 0 1 3.84 5.23l6-.11 2.37 9.67-5.37 2.68a24.17 24.17 0 0 1-1 6.42l4.33 4.17-5.16 8.51-5.7-1.9a24.62 24.62 0 0 1-5.23 3.83l.1 6-9.66 2.37-2.68-5.4a24.56 24.56 0 0 1-6.41-1l-4.17 4.32-8.51-5.16 1.9-5.7a24.28 24.28 0 0 1-3.83-5.23l-6 .11-2.36-9.67 5.37-2.68a24.93 24.93 0 0 1 1-6.41l-4.33-4.18 5.15-8.47 5.71 1.91a24.08 24.08 0 0 1 5.21-3.84l-.11-6 9.66-2.37 2.69 5.37Zm-2.58 14a10.67 10.67 0 1 0 12.9 7.82 10.67 10.67 0 0 0-12.9-7.82Z"
        style={{
          fill: "#e0e0e0",
          transformOrigin: "346.685px 117.515px",
        }}
        className="animable"
      />
      <path
        d="M344.58 107a8 8 0 0 1 2.61-.42 10.69 10.69 0 0 1 6.77 2.32 10.82 10.82 0 0 1 3.1 4 10.94 10.94 0 0 1 .94 5.69 10.16 10.16 0 0 1-.78 3 10.05 10.05 0 0 1-1.7 2.81 10.87 10.87 0 0 1-12.6 3.09 11 11 0 0 1-4.91-4 10.84 10.84 0 0 1-.87-10.42 10.61 10.61 0 0 1 4.93-5.18 7.88 7.88 0 0 1 2.51-.84 26.17 26.17 0 0 0-2.4 1 10.64 10.64 0 0 0-4.64 5.15 10.42 10.42 0 0 0 .94 9.92 10 10 0 0 0 2 2.22 10.24 10.24 0 0 0 2.67 1.6 10.36 10.36 0 0 0 11.91-2.92 9.74 9.74 0 0 0 1.62-2.65 10.05 10.05 0 0 0 .76-2.89 10.59 10.59 0 0 0-.84-5.42 10.48 10.48 0 0 0-2.92-3.82 10.63 10.63 0 0 0-6.49-2.42 23.48 23.48 0 0 0-2.61.18Z"
        style={{
          fill: "#e0e0e0",
          transformOrigin: "347.128px 117.461px",
        }}
        className="animable"
      />
      <path
        d="M347.16 93a2.22 2.22 0 0 1-.19-.33c-.13-.24-.3-.58-.53-1-.47-.93-1.16-2.27-2.05-4h.11l-9.65 2.43.15-.1c0 1.82.08 3.84.13 6v.1l-.1.06a24.09 24.09 0 0 0-5.17 3.82l-.09.09h-.12l-5.71-1.89.26-.09-5.2 8.47v-.29l4.34 4.17.11.1-.05.15a24.41 24.41 0 0 0-1 6.34v.16l-.15.07-5.37 2.7.14-.31c.75 3 1.56 6.31 2.38 9.66l-.28-.22 6-.11h.18l.08.15a23.62 23.62 0 0 0 3.8 5.16l.12.13-.06.17c-.59 1.79-1.24 3.74-1.9 5.71l-.13-.35 8.51 5.15-.37.05 4.17-4.32.13-.14.18.05a24 24 0 0 0 6.32 1h.2l.08.17c.9 1.8 1.8 3.6 2.68 5.38l-.34-.16 9.66-2.37-.23.3c0-2-.07-4-.1-6v-.18l.16-.09a23.83 23.83 0 0 0 5.17-3.79l.13-.12.17.05 5.7 1.91-.34.13q2.65-4.35 5.17-8.5v.34L370 124.6l-.12-.11.05-.16a24.47 24.47 0 0 0 1-6.34v-.16l.14-.07 5.38-2.68-.13.29c-.82-3.4-1.6-6.61-2.35-9.67l.23.18-6 .09h-.13l-.06-.11a24.45 24.45 0 0 0-3.79-5.2l-.09-.09v-.11l1.92-5.7.08.21-8.48-5.19h.17l-4.21 4.3h-.06a24.77 24.77 0 0 0-4.78-1l-1.2-.09a2.19 2.19 0 0 1-.4 0 3.15 3.15 0 0 1 .4 0h1.21a23.7 23.7 0 0 1 4.83.86h-.1l4.15-4.36.07-.08.1.06 8.53 5.12.12.08v.14c-.59 1.76-1.2 3.63-1.89 5.71v-.21a24.56 24.56 0 0 1 3.88 5.26l-.19-.11 6-.12h.18l.05.18c.75 3 1.55 6.26 2.39 9.66v.2l-.18.09-5.37 2.69.15-.23a24.73 24.73 0 0 1-1 6.48l-.08-.27 4.34 4.17.16.16-.12.19q-2.5 4.16-5.15 8.51l-.12.2-.22-.07-5.71-1.9.3-.07a25 25 0 0 1-5.29 3.89l.16-.27c0 2 .07 4 .11 6v.24l-.23.06-9.65 2.45-.23.06-.11-.22q-1.33-2.67-2.69-5.38l.27.17a24.74 24.74 0 0 1-6.48-1l.3-.08-4.18 4.32-.16.18-.21-.13-8.51-5.16-.2-.12.07-.23c.66-2 1.32-3.92 1.91-5.7l.07.3a24.7 24.7 0 0 1-3.88-5.3l.26.15-6 .1H319l-.05-.22-2.36-9.67v-.21l.19-.1 5.39-2.68-.15.23a24.9 24.9 0 0 1 1-6.47l.07.25c-1.51-1.46-3-2.89-4.32-4.19l-.14-.13.1-.17 5.18-8.49.09-.15.16.06 5.7 1.92h-.2a24.73 24.73 0 0 1 5.28-3.85l-.09.16c0-2.16-.06-4.19-.08-6v-.12h.12l9.68-2.31h.08v.07l1.95 4 .49 1c.02.28.07.41.07.41Z"
        style={{
          fill: "#e0e0e0",
          transformOrigin: "346.745px 117.64px",
        }}
        className="animable"
      />
      <path
        d="M375.07 282.52a8.18 8.18 0 0 1 2.63-.42 10.87 10.87 0 0 1 10 6.33 11 11 0 0 1 .94 5.74 11 11 0 0 1-2.5 5.92 11 11 0 0 1-12.71 3.11 10.22 10.22 0 0 1-2.84-1.72 10.11 10.11 0 0 1-2.12-2.37 10.91 10.91 0 0 1-.88-10.51 10.69 10.69 0 0 1 5-5.23 8.2 8.2 0 0 1 2.53-.85 25 25 0 0 0-2.42 1.06 10.71 10.71 0 0 0-4.69 5.2 10.48 10.48 0 0 0-.82 4.77 10.65 10.65 0 0 0 1.77 5.25 9.94 9.94 0 0 0 2 2.23 9.57 9.57 0 0 0 2.69 1.61 10.45 10.45 0 0 0 12-2.94 9.81 9.81 0 0 0 1.64-2.68 10.18 10.18 0 0 0 .76-2.91 10.57 10.57 0 0 0-3.79-9.33 10.72 10.72 0 0 0-6.56-2.44 23.92 23.92 0 0 0-2.63.18Z"
        style={{
          fill: "#ebebeb",
          transformOrigin: "377.669px 293.077px",
        }}
        className="animable"
      />
      <path
        d="m377.67 268.35-.18-.33c-.14-.25-.31-.58-.54-1l-2.07-4h.11l-9.74 2.44.12-.15c0 1.84.08 3.88.13 6.07v.1l-.1.06a24.48 24.48 0 0 0-5.22 3.86l-.09.08h-.11l-5.77-1.9.26-.1-5.19 8.6v-.3l4.37 4.21.11.11v.14a24.52 24.52 0 0 0-1 6.41v.16l-.14.07-5.43 2.72.15-.31c.75 3.06 1.56 6.36 2.4 9.75l-.29-.22 6.07-.11h.18l.08.16a24.63 24.63 0 0 0 3.83 5.21l.13.13-.06.17c-.6 1.81-1.25 3.77-1.92 5.76l-.13-.35 8.59 5.2-.38.05 4.22-4.37.13-.13.18.05a24.39 24.39 0 0 0 6.38 1h.19l.09.16q1.36 2.74 2.71 5.43l-.35-.16 9.75-2.39-.23.3c0-2-.07-4.06-.11-6.06v-.19l.16-.08a24.56 24.56 0 0 0 5.22-3.83l.13-.12.17.06 5.75 1.92-.34.13 5.21-8.58.05.35-4.36-4.22-.12-.12.05-.16a24.5 24.5 0 0 0 1-6.4v-.16l.15-.07 5.43-2.7-.13.29c-.84-3.43-1.62-6.67-2.37-9.76l.23.18-6.07.09h-.13l-.06-.11a24.68 24.68 0 0 0-3.83-5.25l-.09-.08v-.12c.71-2.09 1.34-4 1.94-5.75l.08.21-8.56-5.24h.17c-1.69 1.73-3.09 3.15-4.24 4.34h-.1a25.4 25.4 0 0 0-4.83-.95l-1.21-.1h-.41 1.63a24.27 24.27 0 0 1 4.87.87h-.1l4.19-4.4.08-.08.09.06L397 270l.13.08-.05.13-1.9 5.77-.05-.21a24.7 24.7 0 0 1 3.92 5.31l-.19-.11 6.06-.12h.19l.05.19 2.41 9.75v.2l-.18.09-5.42 2.72.15-.24a25.2 25.2 0 0 1-1 6.55l-.08-.28 4.38 4.21.16.16-.12.19q-2.54 4.2-5.2 8.59l-.12.2-.22-.07-5.76-1.92.3-.07a24.88 24.88 0 0 1-5.34 3.93l.16-.27c0 2 .07 4 .11 6.06v.25l-.23.06-9.76 2.39-.24.06-.11-.22c-.89-1.8-1.8-3.61-2.71-5.43l.27.17a24.79 24.79 0 0 1-6.55-1l.31-.08c-1.45 1.5-2.88 3-4.22 4.36l-.17.18-.21-.13-8.58-5.21-.21-.12.08-.23c.66-2 1.32-3.95 1.93-5.76l.06.3a24.83 24.83 0 0 1-3.91-5.34l.26.15-6.07.1h-.23l-.05-.22c-.83-3.39-1.63-6.7-2.38-9.76l-.05-.22.2-.09c1.89-.94 3.74-1.87 5.43-2.7l-.15.23a25 25 0 0 1 1-6.54l.07.26-4.36-4.23-.14-.13.1-.17q2.75-4.52 5.23-8.57l.09-.15.16.05 5.76 1.94-.21.05a24.87 24.87 0 0 1 5.33-3.89l-.09.16c0-2.18-.06-4.23-.09-6.06v-.13h.12l9.77-2.33h.08v.07q1.27 2.64 2 4.05l.49 1.05a1.48 1.48 0 0 1 .26.34Z"
        style={{
          fill: "#ebebeb",
          transformOrigin: "377.095px 293.22px",
        }}
        className="animable"
      />
      <path
        style={{
          fill: "#f5f5f5",
          transformOrigin: "103.655px 465.87px",
        }}
        className="animable"
        d="M56.23 450.45v30.84h94.85v-30.84H56.23z"
      />
      <path
        style={{
          fill: "#e0e0e0",
          transformOrigin: "103.325px 446.135px",
        }}
        className="animable"
        d="M52.25 441.82v8.63H154.4v-8.63H52.25z"
      />
      <path
        style={{
          fill: "#e0e0e0",
          transformOrigin: "127.865px 461.555px",
        }}
        className="animable"
        d="M103.32 481.29h47.76v-30.84h3.32v-8.63h-53.07v7.83l1.99 31.64z"
      />
      <path
        style={{
          fill: "#e0e0e0",
          transformOrigin: "79.11px 457.74px",
        }}
        className="animable"
        d="M69.49 455.42h19.24v4.64H69.49z"
      />
      <path
        style={{
          fill: "#fff",
          transformOrigin: "79.37px 470.77px",
        }}
        className="animable"
        d="M67.02 465.87h24.7v9.8h-24.7z"
      />
      <path
        style={{
          fill: "#f5f5f5",
          transformOrigin: "118.245px 426.445px",
        }}
        className="animable"
        d="M70.82 411.02v30.85h94.85v-30.85H70.82z"
      />
      <path
        style={{
          fill: "#e0e0e0",
          transformOrigin: "117.915px 406.71px",
        }}
        className="animable"
        d="M66.84 402.4v8.62h102.15v-8.62H66.84z"
      />
      <path
        style={{
          fill: "#e0e0e0",
          transformOrigin: "142.46px 422.135px",
        }}
        className="animable"
        d="M117.92 441.87h47.75v-30.85h3.32v-8.62h-53.06v7.83l1.99 31.64z"
      />
      <path
        style={{
          fill: "#e0e0e0",
          transformOrigin: "93.71px 418.32px",
        }}
        className="animable"
        d="M84.09 416h19.24v4.64H84.09z"
      />
      <path
        style={{
          fill: "#fff",
          transformOrigin: "93.96px 431.34px",
        }}
        className="animable"
        d="M81.61 426.44h24.7v9.8h-24.7z"
      />
    </g>
    <g
      className="animable"
      style={{
        transformOrigin: "250px 481.275px",
      }}
    >
      <path
        d="M480.66 481.29c0 .14-103.28.26-230.65.26s-230.67-.12-230.67-.26S122.6 481 250 481s230.66.15 230.66.29Z"
        style={{
          fill: "#263238",
          transformOrigin: "250px 481.275px",
        }}
        className="animable"
      />
    </g>
    <g
      className="animable"
      style={{
        transformOrigin: "252.49px 159.542px",
      }}
    >
      <Wheel2
        d="M86.19 61.42A48 48 0 0 1 98 56.36l2.45-11.61 19.55-.28L122.83 56a47.92 47.92 0 0 1 11.89 4.73l9.95-6.47L158.75 68l-6.19 10.12a48 48 0 0 1 5.07 11.76l11.61 2.46.28 19.63-11.52 2.75a48.38 48.38 0 0 1-4.73 11.9l6.47 9.94L146 150.65l-10.12-6.19a48 48 0 0 1-11.76 5.06l-2.46 11.61-19.64.28-2.79-11.54a47.92 47.92 0 0 1-11.89-4.73l-10 6.47-14-13.69 6.19-10.12a48 48 0 0 1-5.06-11.8l-11.62-2.46L52.58 94l11.54-2.79a48 48 0 0 1 4.72-11.9l-6.47-9.94 13.69-14.14 10.13 6.19Z"
        style={{
          fill: "#f6a293",
          fillRule: "evenodd",
          transformOrigin: "111.05px 102.94px",
        }}
        className="animable"
      />
      <path
        d="M122.63 97.16A25.15 25.15 0 0 0 122 93a16.09 16.09 0 0 0-1.89-4.48 16.93 16.93 0 0 0-11.38-7.88 16.77 16.77 0 0 0-8.8.75 16 16 0 0 0-4.24 2.28 15.47 15.47 0 0 0-3.54 3.56 16.69 16.69 0 0 0 0 19.79 20.62 20.62 0 0 0 1.64 2 18 18 0 0 0 1.9 1.61 15.75 15.75 0 0 0 4.24 2.29 16.86 16.86 0 0 0 8.8.74 16.93 16.93 0 0 0 11.38-7.88 16.33 16.33 0 0 0 1.9-4.48 25.63 25.63 0 0 0 .62-4.12.8.8 0 0 1 0 .27v.81a7.6 7.6 0 0 1-.11 1.32 11.33 11.33 0 0 1-.32 1.77 16.08 16.08 0 0 1-1.84 4.58 17.14 17.14 0 0 1-11.55 8.16 17.29 17.29 0 0 1-9-.72 16.36 16.36 0 0 1-4.42-2.37 15.81 15.81 0 0 1-3.65-3.65 17.16 17.16 0 0 1 0-20.4 19.2 19.2 0 0 1 1.69-2 20.26 20.26 0 0 1 2-1.66A16 16 0 0 1 99.76 81 17.1 17.1 0 0 1 116 83.5a17 17 0 0 1 4.33 4.9 16.19 16.19 0 0 1 1.87 4.6 11.65 11.65 0 0 1 .32 1.78 7.42 7.42 0 0 1 .11 1.31v.81a.9.9 0 0 1 0 .26Z"
        style={{
          fill: "#fff",
          transformOrigin: "105.51px 97.1777px",
        }}
        className="animable"
      />
      <path
        d="M117.28 109.54c.1-.1 3.8 3.44 8.27 7.91s8 8.17 7.91 8.27-3.81-3.44-8.28-7.9-8-8.18-7.9-8.28Z"
        style={{
          fill: "#fff",
          transformOrigin: "125.37px 117.63px",
        }}
        className="animable"
      />
      <Wheel1
        d="M220.43 135.73a61.42 61.42 0 0 1 15.09-6.5l3.16-14.91 25.2-.35 3.58 14.81a61.54 61.54 0 0 1 15.27 6.07l12.77-8.31 18.07 17.57-7.94 13a62 62 0 0 1 6.5 15.09l14.9 3.16.36 25.2-14.81 3.58a61.93 61.93 0 0 1-6.07 15.27l8.3 12.77-17.57 18.07-13-7.94a62 62 0 0 1-15.1 6.5l-3.14 14.9-25.21.36-3.58-14.81a61.85 61.85 0 0 1-15.27-6.07l-12.76 8.3-18.08-17.57 7.94-13a61.62 61.62 0 0 1-6.49-15.1l-14.91-3.15-.35-25.21 14.81-3.57a61.54 61.54 0 0 1 6.07-15.27l-8.31-12.77 17.57-18.08 13 7.95Z"
        style={{
          fill: "#f6a293",
          fillRule: "evenodd",
          transformOrigin: "252.34px 189.02px",
        }}
        className="animable"
      />
      <path
        d="M243.81 215.28h4.47l12.37-.08-.15.15c-.05-2.12-.11-4.51-.17-7.07v-.12l.11-.05A38.06 38.06 0 0 0 271 200.8a26.72 26.72 0 0 0 4.44-5.68 19.66 19.66 0 0 0 2.44-7.23 24.05 24.05 0 0 0-3.79-15.84 28.77 28.77 0 0 0-13.79-11 23.73 23.73 0 0 0-13.24-.92 26 26 0 0 0-11.51 5.32 23.39 23.39 0 0 0-6.94 9.59c-.31.91-.7 1.78-.93 2.69s-.44 1.82-.66 2.71a28.86 28.86 0 0 0-.47 5.34 24.81 24.81 0 0 0 .63 5 23.08 23.08 0 0 0 1.63 4.48 25.77 25.77 0 0 0 5 6.91 34.14 34.14 0 0 0 10.32 7.05h.06v.06q-.18 2.9-.27 4.41c0 .49 0 .86-.07 1.14a2.55 2.55 0 0 1 0 .39 1.53 1.53 0 0 1 0-.36v-1.12c0-1 .09-2.51.16-4.47l.06.1a33.88 33.88 0 0 1-10.47-7 25.71 25.71 0 0 1-5.1-7 23.44 23.44 0 0 1-1.68-4.55 25.79 25.79 0 0 1-.67-5.12 29.79 29.79 0 0 1 .46-5.43c.22-.91.44-1.82.66-2.75s.63-1.82.94-2.74a23.9 23.9 0 0 1 7.06-9.81 26.49 26.49 0 0 1 11.73-5.34 24.19 24.19 0 0 1 13.52.93 29.23 29.23 0 0 1 14 11.21 23.93 23.93 0 0 1 3.37 7.95 14.5 14.5 0 0 1 .38 2.07 13.19 13.19 0 0 1 .2 2.07c0 .69.06 1.38.07 2.06l-.19 2a19.82 19.82 0 0 1-2.52 7.39 27.21 27.21 0 0 1-4.53 5.77 38.36 38.36 0 0 1-10.74 7.26l.11-.17c0 2.56.08 5 .11 7.08v.16h-.16l-12.46-.08h-4.11Z"
        style={{
          fill: "#fff",
          transformOrigin: "252.345px 187.241px",
        }}
        className="animable"
      />
      <path
        d="M260.89 220a71.66 71.66 0 0 1-8.65.27 73 73 0 0 1-8.65-.26 73 73 0 0 1 8.65-.26 71.91 71.91 0 0 1 8.65.25Z"
        style={{
          fill: "#fff",
          transformOrigin: "252.24px 220.008px",
        }}
        className="animable"
      />
      <path
        d="M255.29 226.5a6.66 6.66 0 0 1-3.06.36 6.74 6.74 0 0 1-3-.55 15 15 0 0 1 3.05 0 14.73 14.73 0 0 1 3.01.19Z"
        style={{
          fill: "#fff",
          transformOrigin: "252.26px 226.569px",
        }}
        className="animable"
      />
      <path
        d="M247.34 215.28a.9.9 0 0 1 0-.28v-.84c0-.78 0-1.85.05-3.22.07-2.83.16-6.86.28-11.83.06-2.5.14-5.23.21-8.17a5.37 5.37 0 0 0-.29-2.11 1.39 1.39 0 0 0-1.52-1 2 2 0 0 0-1.34 1.52 3.1 3.1 0 0 0 .28 2.2 5 5 0 0 0 3.86 2.57 5.14 5.14 0 0 0 4.5-1.8 7.68 7.68 0 0 0 1.89-4.84 4.56 4.56 0 0 0-.53-2.56 1.88 1.88 0 0 0-2.11-.9 1.9 1.9 0 0 0-1 2.07 5.23 5.23 0 0 0 1.2 2.35 9.52 9.52 0 0 0 4.17 3.22 5.42 5.42 0 0 0 2.51.3 5.07 5.07 0 0 0 2.28-.95 4 4 0 0 0 1.43-1.9 2.92 2.92 0 0 0-.13-2.25 1.94 1.94 0 0 0-1.71-1.16 2.37 2.37 0 0 0-1.79 1.07c-.83 1.23-.84 2.84-1.05 4.27-.32 2.91-.53 5.64-.72 8.13-.33 5-.6 9-.79 11.8-.1 1.37-.17 2.44-.22 3.21 0 .35-.05.62-.07.84a1.18 1.18 0 0 1 0 .28 1.23 1.23 0 0 1 0-.28v-.84c0-.77.07-1.85.12-3.22.12-2.79.31-6.83.64-11.81.16-2.5.35-5.23.65-8.16.09-.73.16-1.47.29-2.23a5.46 5.46 0 0 1 .81-2.25 2.83 2.83 0 0 1 2.16-1.28 2.42 2.42 0 0 1 2.14 1.41 3.38 3.38 0 0 1 .17 2.63 4.46 4.46 0 0 1-1.59 2.14 5.55 5.55 0 0 1-2.51 1.05 5.85 5.85 0 0 1-2.75-.32 9.94 9.94 0 0 1-4.4-3.38 5.55 5.55 0 0 1-1.31-2.59 2.42 2.42 0 0 1 1.35-2.64 2.39 2.39 0 0 1 2.74 1.12 5 5 0 0 1 .6 2.85 8.2 8.2 0 0 1-2 5.16 5.62 5.62 0 0 1-4.94 2 5.48 5.48 0 0 1-4.23-2.85 3.61 3.61 0 0 1-.3-2.54 2.47 2.47 0 0 1 1.71-1.84 1.68 1.68 0 0 1 1.27.29 2.22 2.22 0 0 1 .75 1 5.75 5.75 0 0 1 .3 2.3c-.1 2.93-.19 5.66-.28 8.16-.18 5-.33 9-.44 11.83-.06 1.36-.11 2.44-.15 3.21v.84a1 1 0 0 1-.19.22Z"
        style={{
          fill: "#fff",
          transformOrigin: "254.081px 199.369px",
        }}
        className="animable"
      />
      <path
        d="M259.37 223.23a46.55 46.55 0 0 1-7 .26 46.55 46.55 0 0 1-7-.26 48.18 48.18 0 0 1 7-.26 48.18 48.18 0 0 1 7 .26Z"
        style={{
          fill: "#fff",
          transformOrigin: "252.37px 223.232px",
        }}
        className="animable"
      />
      <Wheel2
        d="M385.94 176a39.63 39.63 0 0 1 9.73-4.37l1.89-9.7 16.35-.49 2.47 9.57a40 40 0 0 1 10 3.78l8.2-5.51 11.9 11.21-5 8.51a40.57 40.57 0 0 1 4.37 9.73l9.7 1.9.48 16.34-9.57 2.47a40 40 0 0 1-3.78 10l5.52 8.2-11.22 11.9-8.51-5a40 40 0 0 1-9.73 4.37l-1.89 9.7-16.35.49-2.5-9.65a40.39 40.39 0 0 1-10-3.79l-8.19 5.52-11.9-11.18 5-8.51a40.32 40.32 0 0 1-4.37-9.72l-9.7-1.9-.48-16.35L368 201a39.9 39.9 0 0 1 3.78-10l-5.52-8.2 11.17-11.8 8.51 5Z"
        style={{
          fill: "#f6a293",
          fillRule: "evenodd",
          transformOrigin: "407.195px 210.27px",
        }}
        className="animable"
      />
      <path
        d="M429.09 227.81a4.83 4.83 0 0 1-.79.05h-2.27l-8.37.08-27.59.08h-2.23v-.26c0-10.31.06-19.55.08-26.28 0-3.3.07-6 .09-7.9v-2.14a6 6 0 0 1 .05-.74 3.24 3.24 0 0 1 0 .74c0 .54 0 1.25.05 2.14 0 1.92.05 4.6.08 7.9 0 6.73.05 16 .08 26.28l-.26-.26h2l27.59.07 8.37.09h2.27a4 4 0 0 1 .85.15Z"
        style={{
          fill: "#fff",
          transformOrigin: "408.465px 209.36px",
        }}
        className="animable"
      />
      <path
        d="M424.54 199.74a10.59 10.59 0 0 1-1.22 1.17l-3.46 3c-2.94 2.55-7 6.05-11.55 9.88l-.68.58-.18.15-.17-.16-5.13-4.77h.32l-7.54 6.22-2.19 1.75a4.76 4.76 0 0 1-.82.58 4.19 4.19 0 0 1 .72-.7l2.1-1.86 7.42-6.36.16-.14.16.14 5.15 4.75h-.34l.69-.58c4.52-3.83 8.64-7.28 11.64-9.76l3.57-2.91a10.19 10.19 0 0 1 1.35-.98Z"
        style={{
          fill: "#fff",
          transformOrigin: "408.23px 208.94px",
        }}
        className="animable"
      />
      <path
        d="M424.54 208.33a13.27 13.27 0 0 1-.18-2.56c-.05-1.59-.08-3.78-.08-6.23l.26.26h-.44c-2.55 0-4.86 0-6.53-.08a14.88 14.88 0 0 1-2.71-.18 14.23 14.23 0 0 1 2.71-.19c1.67 0 4-.07 6.53-.07h.7v.26c0 2.45 0 4.64-.08 6.23a13.27 13.27 0 0 1-.18 2.56Z"
        style={{
          fill: "#fff",
          transformOrigin: "419.83px 203.805px",
        }}
        className="animable"
      />
      <path
        d="M160 229.24a9.15 9.15 0 0 1-1.16-2.78 8.9 8.9 0 0 1-.66-2.94 8.87 8.87 0 0 1 1.16 2.78 8.76 8.76 0 0 1 .66 2.94Z"
        style={{
          fill: "#263238",
          transformOrigin: "159.09px 226.38px",
        }}
        className="animable"
      />
      <path
        d="M170.64 250.64a40.64 40.64 0 0 1-6-10.38 56.77 56.77 0 0 1 3.05 5.15 53.42 53.42 0 0 1 2.95 5.23Z"
        style={{
          fill: "#263238",
          transformOrigin: "167.64px 245.45px",
        }}
        className="animable"
      />
      <path
        d="M186.24 268.71a39.41 39.41 0 0 1-8.38-8.53 55.79 55.79 0 0 1 4.24 4.22 55.27 55.27 0 0 1 4.14 4.31Z"
        style={{
          fill: "#263238",
          transformOrigin: "182.05px 264.445px",
        }}
        className="animable"
      />
      <path
        d="M206 282.1a25.6 25.6 0 0 1-5.41-2.61 24.5 24.5 0 0 1-4.93-3.42 58.53 58.53 0 0 1 5.19 3 55.4 55.4 0 0 1 5.15 3.03Z"
        style={{
          fill: "#263238",
          transformOrigin: "200.83px 279.085px",
        }}
        className="animable"
      />
      <path
        d="M228.72 289.42a37.27 37.27 0 0 1-11.62-2.82 35.44 35.44 0 0 1 5.82 1.38 35.58 35.58 0 0 1 5.8 1.44Z"
        style={{
          fill: "#263238",
          transformOrigin: "222.91px 288.01px",
        }}
        className="animable"
      />
      <path
        d="M252.59 289.94a25.28 25.28 0 0 1-6 .71 25.56 25.56 0 0 1-6-.18 53 53 0 0 1 6-.34 56.4 56.4 0 0 1 6-.19Z"
        style={{
          fill: "#263238",
          transformOrigin: "246.59px 290.338px",
        }}
        className="animable"
      />
      <path
        d="M275.92 284.79a26.4 26.4 0 0 1-5.64 2 25.93 25.93 0 0 1-5.88 1.2 51.58 51.58 0 0 1 5.74-1.7 48.86 48.86 0 0 1 5.78-1.5Z"
        style={{
          fill: "#263238",
          transformOrigin: "270.16px 286.39px",
        }}
        className="animable"
      />
      <path
        d="M297.57 274.65a41.49 41.49 0 0 1-10.57 5.67 51 51 0 0 1 5.23-2.91 52.26 52.26 0 0 1 5.34-2.76Z"
        style={{
          fill: "#263238",
          transformOrigin: "292.285px 277.485px",
        }}
        className="animable"
      />
      <path
        d="M316.12 259.62a23.61 23.61 0 0 1-4.06 4.42 25.13 25.13 0 0 1-4.71 3.72 56.72 56.72 0 0 1 4.36-4.1c2.42-2.24 4.29-4.14 4.41-4.04Z"
        style={{
          fill: "#263238",
          transformOrigin: "311.735px 263.688px",
        }}
        className="animable"
      />
      <path
        d="M329.33 239.77a24.37 24.37 0 0 1-2.46 5.48 23.31 23.31 0 0 1-3.32 5c-.12-.09 1.29-2.36 2.86-5.25a57.82 57.82 0 0 1 2.92-5.23Z"
        style={{
          fill: "#263238",
          transformOrigin: "326.436px 245.01px",
        }}
        className="animable"
      />
      <path
        d="M337.53 217.3a34.54 34.54 0 0 1-1.62 5.76 34.41 34.41 0 0 1-2.12 5.61 34.22 34.22 0 0 1 1.62-5.77 33.44 33.44 0 0 1 2.12-5.6Z"
        style={{
          fill: "#263238",
          transformOrigin: "335.66px 222.985px",
        }}
        className="animable"
      />
      <path
        d="M345.18 194.61c.16.07-.76 2.58-1.84 5.7a34.18 34.18 0 0 1-2.21 5.57 33.53 33.53 0 0 1 1.72-5.74c.53-1.57 1.1-3 1.53-3.95a6.82 6.82 0 0 1 .8-1.58Z"
        style={{
          fill: "#263238",
          transformOrigin: "343.164px 200.245px",
        }}
        className="animable"
      />
      <path
        d="M355.79 173.19a49.71 49.71 0 0 1-2.83 5.27 51.1 51.1 0 0 1-3 5.19 26.27 26.27 0 0 1 2.53-5.44 26.06 26.06 0 0 1 3.3-5.02Z"
        style={{
          fill: "#263238",
          transformOrigin: "352.875px 178.42px",
        }}
        className="animable"
      />
      <path
        d="M371.76 155.52c.09.12-2 1.78-4.42 4s-4.25 4.19-4.36 4.08a22 22 0 0 1 4-4.46 21.44 21.44 0 0 1 4.78-3.62Z"
        style={{
          fill: "#263238",
          transformOrigin: "367.371px 159.562px",
        }}
        className="animable"
      />
      <path
        d="M393.32 145.42a58.62 58.62 0 0 1-5.62 2c-3.1 1.11-5.57 2.15-5.63 2a23.89 23.89 0 0 1 5.46-2.5 24.41 24.41 0 0 1 5.79-1.5Z"
        style={{
          fill: "#263238",
          transformOrigin: "387.695px 147.427px",
        }}
        className="animable"
      />
      <path
        d="M417 142.78c0 .15-2.69.08-6 .2s-6 .33-6 .18a24.39 24.39 0 0 1 6-.7 23 23 0 0 1 6 .32Z"
        style={{
          fill: "#263238",
          transformOrigin: "411px 142.801px",
        }}
        className="animable"
      />
      <path
        d="M440.1 148.67a55.5 55.5 0 0 1-5.66-1.95c-3.1-1.11-5.66-1.9-5.62-2a24.42 24.42 0 0 1 5.8 1.55 25.37 25.37 0 0 1 5.48 2.4Z"
        style={{
          fill: "#263238",
          transformOrigin: "434.46px 146.695px",
        }}
        className="animable"
      />
      <path
        d="M460.46 161.13c-.1.11-2.2-1.54-4.89-3.45s-4.92-3.38-4.85-3.51a25.5 25.5 0 0 1 5.15 3.08 24 24 0 0 1 4.59 3.88Z"
        style={{
          fill: "#263238",
          transformOrigin: "455.589px 157.653px",
        }}
        className="animable"
      />
      <path
        d="M472.47 174.4a26.18 26.18 0 0 1-3.56-4.82 13 13 0 0 1 3.56 4.82Z"
        style={{
          fill: "#263238",
          transformOrigin: "470.69px 171.99px",
        }}
        className="animable"
      />
      <path
        d="M32.51 88.66s.05-.31.18-.9l.6-2.65a68 68 0 0 1 3.33-9.89A74.44 74.44 0 0 1 44.89 61a82.21 82.21 0 0 1 15.26-15.67 80.9 80.9 0 0 1 23.26-12.58 85.11 85.11 0 0 1 14.36-3.47 92.43 92.43 0 0 1 15.65-.91 81.77 81.77 0 0 1 16.33 2.07 74.44 74.44 0 0 1 16.19 5.72A72.59 72.59 0 0 1 160.75 46 69.87 69.87 0 0 1 173 59.59 67.56 67.56 0 0 1 181.28 76 77.25 77.25 0 0 1 185 93.34c.11 1.46.27 2.91.34 4.35s.06 2.89.1 4.32-.08 2.87-.11 4.29-.23 2.83-.41 4.22a62.93 62.93 0 0 1-4.3 15.9 123.26 123.26 0 0 1-7.1 14q-3.86 6.57-7.46 12.74a74.76 74.76 0 0 0-8.73 24.8 109.79 109.79 0 0 0-1.42 11.44c-.27 3.63-.39 7.07-.41 10.29a113.49 113.49 0 0 0 .78 16.45 66.15 66.15 0 0 0 2.28 10.15c.37 1.14.68 2 .91 2.55.11.29.21.5.27.64a1.63 1.63 0 0 1 .08.22 23.06 23.06 0 0 1-1.35-3.38 61.44 61.44 0 0 1-2.39-10.15 112.66 112.66 0 0 1-.87-16.49c0-3.22.11-6.66.37-10.3a107.69 107.69 0 0 1 1.42-11.53 75 75 0 0 1 8.71-24.95l7.44-12.74a122.66 122.66 0 0 0 7.06-13.93 63.14 63.14 0 0 0 4.25-15.77c.18-1.39.27-2.79.4-4.19s.12-2.83.1-4.25-.07-2.86-.1-4.3-.23-2.88-.34-4.33a76.2 76.2 0 0 0-3.73-17.27 66.69 66.69 0 0 0-8.18-16.23 69.19 69.19 0 0 0-12.2-13.48 72.15 72.15 0 0 0-14.69-9.79 73.47 73.47 0 0 0-16.08-5.69 80.83 80.83 0 0 0-16.24-2.08 92.44 92.44 0 0 0-15.56.88 85 85 0 0 0-14.29 3.43 80.67 80.67 0 0 0-23.17 12.46 82.06 82.06 0 0 0-15.25 15.5A75.16 75.16 0 0 0 36.8 75.3a71.18 71.18 0 0 0-3.41 9.84l-.65 2.63Z"
        style={{
          fill: "#263238",
          transformOrigin: "108.979px 129.018px",
        }}
        className="animable"
      />
    </g>
    <AnimateCharacter
      className="animable"
      style={{
        transformOrigin: "235.86px 353.19px",
      }}
    >
      <path
        d="m275.9 456.39 15 5.26-.16 14.43c-7.18 2-8.19 5.66-8.19 5.66l15-.34 13.06-26.57-10.33-6.76-19.28-8.46"
        style={{
          fill: "#f6a293",
          transformOrigin: "293.255px 460.675px",
        }}
        className="animable"
      />
      <g
        style={{
          opacity: 0.6,
          transformOrigin: "296.59px 467.565px",
        }}
        className="animable"
      >
        <path
          style={{
            fill: "#fff",
            transformOrigin: "296.59px 467.565px",
          }}
          className="animable"
          d="m310.63 454.83-13.06 26.57-15.02.34 1.64-2.29 12.2-.95 12.05-25.11 2.19 1.44z"
        />
      </g>
      <path
        d="M290.69 469.47c.11.15 1-.36 2.13-.35s2 .47 2.14.32-.73-1-2.14-1-2.27.92-2.13 1.03Z"
        style={{
          fill: "#263238",
          transformOrigin: "292.825px 468.969px",
        }}
        className="animable"
      />
      <path
        d="M290.85 465.89c.16.1.8-.8 2-1.06s2.16.27 2.25.11-.13-.32-.55-.54a2.78 2.78 0 0 0-1.85-.21 2.74 2.74 0 0 0-1.57 1c-.3.36-.35.66-.28.7Z"
        style={{
          fill: "#263238",
          transformOrigin: "292.971px 465.008px",
        }}
        className="animable"
      />
      <path
        d="M290.65 461.3c.17.08.66-.8 1.7-1.19s2-.06 2.06-.23-.16-.28-.58-.43a2.61 2.61 0 0 0-3 1.15c-.25.4-.26.67-.18.7Z"
        style={{
          fill: "#263238",
          transformOrigin: "292.513px 460.32px",
        }}
        className="animable"
      />
      <path
        d="M289.55 461.29c.18 0 .07-1 .52-2s1.18-1.6 1.09-1.76-1.17.25-1.7 1.5-.07 2.34.09 2.26Z"
        style={{
          fill: "#263238",
          transformOrigin: "290.19px 459.396px",
        }}
        className="animable"
      />
      <path
        d="M287.77 459.6a6.45 6.45 0 0 0 .35-2c.07-.72.14-1.45.2-2.2a4.35 4.35 0 0 0 0-1.4 1.21 1.21 0 0 0-.53-.74.94.94 0 0 0-1 0 2.84 2.84 0 0 0-.86 1.33 5.2 5.2 0 0 0-.27 1.36 5 5 0 0 0 .4 2.27c.54 1.23 1.29 1.66 1.32 1.61a16.29 16.29 0 0 1-.88-1.77 5.17 5.17 0 0 1-.23-2.07 5.26 5.26 0 0 1 .27-1.18 2.38 2.38 0 0 1 .62-1 .28.28 0 0 1 .31 0 .61.61 0 0 1 .25.35 5.25 5.25 0 0 1 0 1.2c0 .75 0 1.48-.06 2.2a6.36 6.36 0 0 0 .11 2.04Z"
        style={{
          fill: "#263238",
          transformOrigin: "287.014px 456.475px",
        }}
        className="animable"
      />
      <path
        d="M287.53 460.25c.06 0-.39-.69-1.54-1.07a3.75 3.75 0 0 0-4.26 1.52.7.7 0 0 0 .06.58.86.86 0 0 0 .4.33 2.54 2.54 0 0 0 .7.14 6.2 6.2 0 0 0 1.22 0 6.58 6.58 0 0 0 2-.5c1.07-.47 1.57-1 1.52-1.08s-.64.31-1.68.64a7.91 7.91 0 0 1-1.87.34 7.12 7.12 0 0 1-1.12 0 1.57 1.57 0 0 1-.5-.1c-.13-.07-.1-.05-.09-.1a1.08 1.08 0 0 1 .29-.35 3.65 3.65 0 0 1 .44-.36 3.58 3.58 0 0 1 1-.46 3.67 3.67 0 0 1 1.81-.1 16.19 16.19 0 0 1 1.62.57Z"
        style={{
          fill: "#263238",
          transformOrigin: "284.663px 460.394px",
        }}
        className="animable"
      />
      <g
        style={{
          opacity: 0.6,
          transformOrigin: "300.43px 454.6px",
        }}
        className="animable"
      >
        <path
          d="M298.65 454.64a1.78 1.78 0 0 0 3.56-.08 1.78 1.78 0 0 0-3.56.08Z"
          style={{
            fill: "#fff",
            transformOrigin: "300.43px 454.6px",
          }}
          className="animable"
        />
      </g>
      <path
        d="m198.89 450.35.21 19.65s-19.92 6.81-20.24 10.45l38.14 1 .94-30.64Z"
        style={{
          fill: "#f6a293",
          transformOrigin: "198.4px 465.9px",
        }}
        className="animable"
      />
      <g
        style={{
          opacity: 0.6,
          transformOrigin: "210.499px 470.045px",
        }}
        className="animable"
      >
        <path
          d="M210.93 468.66a1.56 1.56 0 0 1 1 1.81 1.49 1.49 0 0 1-1.78 1 1.64 1.64 0 0 1-1.08-1.91 1.55 1.55 0 0 1 2-.88"
          style={{
            fill: "#fff",
            transformOrigin: "210.499px 470.045px",
          }}
          className="animable"
        />
      </g>
      <g
        style={{
          opacity: 0.6,
          transformOrigin: "197.935px 479.885px",
        }}
        className="animable"
      >
        <path
          d="M217 481.43v-3.09l-36.56.22s-1.72.7-1.56 1.9Z"
          style={{
            fill: "#fff",
            transformOrigin: "197.935px 479.885px",
          }}
          className="animable"
        />
      </g>
      <path
        d="M198.48 469.8c0 .19.93.3 1.84.92s1.36 1.42 1.54 1.35-.08-1.15-1.18-1.89-2.23-.55-2.2-.38Z"
        style={{
          fill: "#263238",
          transformOrigin: "200.196px 470.86px",
        }}
        className="animable"
      />
      <path
        d="M194.44 471.36c-.05.17.75.51 1.37 1.32s.77 1.64 1 1.63.33-1.05-.45-2-1.91-1.13-1.92-.95Z"
        style={{
          fill: "#263238",
          transformOrigin: "195.707px 472.804px",
        }}
        className="animable"
      />
      <path
        d="M192.05 476.08c.17.05.45-.88 0-1.91s-1.32-1.46-1.4-1.3.44.71.8 1.56.41 1.63.6 1.65Z"
        style={{
          fill: "#263238",
          transformOrigin: "191.468px 474.46px",
        }}
        className="animable"
      />
      <path
        d="M198.94 465.32c.07.17.93-.07 2 0s1.86.45 2 .3-.67-.85-1.91-.94-2.18.49-2.09.64Z"
        style={{
          fill: "#263238",
          transformOrigin: "200.945px 465.163px",
        }}
        className="animable"
      />
      <g
        style={{
          opacity: 0.3,
          transformOrigin: "208.38px 456.155px",
        }}
        className="animable"
      >
        <path
          className="animable"
          style={{
            transformOrigin: "208.38px 456.155px",
          }}
          d="m198.94 454.25.03 3.5 18.75.31.1-3.16-18.88-.65z"
        />
      </g>
      <path
        d="M199 461.35a3.55 3.55 0 0 0 1.91 0 8.8 8.8 0 0 0 2-.56 9.63 9.63 0 0 0 1.11-.56 2.57 2.57 0 0 0 .59-.43.82.82 0 0 0 .11-1 1 1 0 0 0-.8-.45 3 3 0 0 0-.72.08 8 8 0 0 0-1.2.38 6.7 6.7 0 0 0-1.79 1.11c-.91.8-1.23 1.49-1.16 1.52s.52-.51 1.44-1.16a7.53 7.53 0 0 1 1.73-.91 6.47 6.47 0 0 1 1.11-.31c.4-.1.75-.09.85.09s0 .09 0 .21a2 2 0 0 1-.43.32 11.54 11.54 0 0 1-1 .55 10.79 10.79 0 0 1-1.86.66 14 14 0 0 0-1.89.46Z"
        style={{
          fill: "#263238",
          transformOrigin: "201.921px 459.915px",
        }}
        className="animable"
      />
      <path
        d="M199.2 461.62c.07 0 .45-.62.55-1.83a6.15 6.15 0 0 0-.2-2.1 6.59 6.59 0 0 0-.46-1.17 1.56 1.56 0 0 0-1.19-1 .9.9 0 0 0-.82.51 2.56 2.56 0 0 0-.21.69 4.32 4.32 0 0 0 0 1.29 4.39 4.39 0 0 0 .76 2c.72 1 1.49 1.25 1.51 1.19s-.57-.47-1.12-1.43a4.49 4.49 0 0 1-.56-1.81 4.09 4.09 0 0 1 .06-1.1c.07-.41.23-.73.39-.69s.5.32.65.65a6.6 6.6 0 0 1 .44 1 6.91 6.91 0 0 1 .33 1.92c-.01 1.16-.23 1.85-.13 1.88Z"
        style={{
          fill: "#263238",
          transformOrigin: "198.295px 458.57px",
        }}
        className="animable"
      />
      <path
        style={{
          fill: "#263238",
          transformOrigin: "242.86px 429.275px",
        }}
        className="animable"
        d="M287.55 440.33 243.63 424l46.17-6.48 2.32-22.49-86.33 7.53-12.19 17.56 3.21 22.02 84.11 21.38 6.63-23.19z"
      />
      <path
        d="m194.43 456.07-4.2-80.37a22.62 22.62 0 0 1 11.27-18.91 22.62 22.62 0 0 1 18.5-1.88l56 18.68 30.74 7.9s5.24 12.92 2.16 22.95c-3 9.83-13.78 16.36-23.25 13.55-11.77-3.48-65.79-26.71-65.79-26.71v65.44Z"
        style={{
          fill: "#263238",
          transformOrigin: "250.05px 405.233px",
        }}
        className="animable"
      />
      <path
        d="M284.82 418.21a1.89 1.89 0 0 1-.33-.11l-1-.37-3.68-1.47-13.47-5.49L222 392.45l-2.26-.93.36-.24c0 18.18-.06 34.53-.08 46.37 0 5.88-.06 10.64-.08 14v4.79a1.39 1.39 0 0 1 0 .33 1.19 1.19 0 0 1 0-.33v-1c0-.9 0-2.17-.05-3.79 0-3.33 0-8.09-.08-14 0-11.84 0-28.19-.08-46.37v-.39l.36.15 2.26.93 44.31 18.45 13.41 5.65 3.64 1.56.94.42a1.44 1.44 0 0 1 .17.16Z"
        style={{
          fill: "#455a64",
          transformOrigin: "252.275px 423.83px",
        }}
        className="animable"
      />
      <path
        d="M233.09 418.3a18.45 18.45 0 0 1 10.53 5.83c-.11.12-2.11-1.74-5-3.34s-5.57-2.33-5.53-2.49Z"
        style={{
          fill: "#455a64",
          transformOrigin: "238.355px 421.218px",
        }}
        className="animable"
      />
      <path
        d="M215 380.4a26.58 26.58 0 0 1 3 5.44 25.75 25.75 0 0 1 2.09 5.83 61.26 61.26 0 0 1-2.56-5.62 61.14 61.14 0 0 1-2.53-5.65Z"
        style={{
          fill: "#455a64",
          transformOrigin: "217.545px 386.035px",
        }}
        className="animable"
      />
      <path
        style={{
          fill: "#ffbe9d",
          transformOrigin: "204.945px 351.825px",
        }}
        className="animable"
        d="m215.1 344.99-9.9-1.85-10.41 10.61 1.92 6.76 12.13-4.46 6.26-11.06z"
      />
      <path
        d="m178.48 227.16-2.68.22s-4.83.79-4.83.9-2.12 3.07-2.12 3.08l-1.95 3a2.83 2.83 0 0 0 2.72-.5l-.68 1.51a3 3 0 0 0 3.73-1.45 33.72 33.72 0 0 1 2.1-3l.88-.08c.07.18 3.46 5 3.54 4.85s2.88-2.83 2.88-2.83Z"
        style={{
          fill: "#eb996e",
          transformOrigin: "174.485px 231.427px",
        }}
        className="animable"
      />
      <path
        d="m185.67 248 .79-14.84-7.52-8.52-8.27.5-3.38 2.36c.17.82 2.52 1.38 5.05.65a12.72 12.72 0 0 1 5.21-.17l3.18 5.55-2.1 2.32 2.69 14.23Z"
        style={{
          fill: "#ffbe9d",
          transformOrigin: "176.875px 237.36px",
        }}
        className="animable"
      />
      <path
        d="M163.72 228.43h26.88a1.23 1.23 0 0 1 1.23 1.23 1.23 1.23 0 0 1-1.23 1.23h-26.88l-2.63-1.23Z"
        style={{
          fill: "#263238",
          transformOrigin: "176.46px 229.66px",
        }}
        className="animable"
      />
      <path
        d="m177.33 252-2.74-6.73a6.41 6.41 0 0 1-.46-2.7c.12-2.42.3-7.28-.07-8.39-.5-1.51-2.51-6.65-1.38-7.4s2.69-1 3.79 2 4.48 9.52 4.48 9.52l2.56 10.7Z"
        style={{
          fill: "#ffbe9d",
          transformOrigin: "177.925px 239.146px",
        }}
        className="animable"
      />
      <path
        d="M180.61 237.62a19.26 19.26 0 0 1-1.56-2.88c-.9-1.78-2.12-4.37-3.42-7.05a2 2 0 0 0-1.59-1 1.45 1.45 0 0 0-1.34 1 3.88 3.88 0 0 0 .05 1.76c.11.58.24 1.11.36 1.59.53 1.93 1.08 3.06 1 3.09s-.2-.24-.46-.75a16.43 16.43 0 0 1-.89-2.23c-.15-.49-.3-1-.43-1.61a4.1 4.1 0 0 1-.09-2 1.94 1.94 0 0 1 1.78-1.37 2.46 2.46 0 0 1 2 1.27c1.39 2.84 2.49 5.32 3.32 7.18a20.39 20.39 0 0 1 1.27 3Z"
        style={{
          fill: "#eb996e",
          transformOrigin: "176.383px 231.895px",
        }}
        className="animable"
      />
      <path
        style={{
          fill: "#ffbe9d",
          transformOrigin: "289.85px 375.235px",
        }}
        className="animable"
        d="m305.88 381.31-2.75-4.81-29.31-7.34 3.45 5.96 28.61 6.19z"
      />
      <path
        d="m174.78 252 18.45 43.71a17 17 0 0 0 9.19 9.11l39.81 16.35 9.27-25.65-38.77-13.72-25.18-35.91Z"
        style={{
          fill: "#f6a293",
          transformOrigin: "213.14px 283.53px",
        }}
        className="animable"
      />
      <path
        d="M234.72 295.92c0 1-4.3 32.84-4.3 39.34s12.44 13.55 12.44 13.55l13.63 28.93H305l-16.59-31.15-7.5-25a58.67 58.67 0 0 0-15.06-25l-8.11-5.43Z"
        style={{
          fill: "#f6a293",
          transformOrigin: "267.71px 334.45px",
        }}
        className="animable"
      />
      <path
        d="m248.81 321 8.19 34.25-41.12-11.59-7 12.38 53.49 24.37a15 15 0 0 0 18.54-5.05 15 15 0 0 0 2.23-12.36l-12-46.8a11.44 11.44 0 0 0-14.73-8 11.45 11.45 0 0 0-7.6 12.8Z"
        style={{
          fill: "#f6a293",
          transformOrigin: "246.25px 344.687px",
        }}
        className="animable"
      />
      <path
        d="M242.86 348.81a1.56 1.56 0 0 1-.47-.2c-.3-.15-.74-.38-1.3-.69a38.4 38.4 0 0 1-4.51-3 18.5 18.5 0 0 1-5.3-6c-1.32-2.85-1.23-6.35-.75-9.78s1.21-6.68 1.63-9.66.77-5.66.94-7.93.2-4.1.19-5.37a17.82 17.82 0 0 1 0-2 2.05 2.05 0 0 1 .08.51c0 .33.08.82.12 1.46a51.91 51.91 0 0 1 0 5.41c-.12 2.28-.4 5-.84 8s-1.09 6.24-1.58 9.66-.56 6.8.66 9.5a18.53 18.53 0 0 0 5.1 5.95 45.78 45.78 0 0 0 4.39 3.1c1.05.65 1.66 1.01 1.64 1.04Z"
        style={{
          fill: "#263238",
          transformOrigin: "236.533px 326.495px",
        }}
        className="animable"
      />
      <path
        d="M265.53 312a24.42 24.42 0 0 0-5.54-1.33 23.52 23.52 0 0 0-5.67.58 9.77 9.77 0 0 1 5.71-1.1 9.9 9.9 0 0 1 5.5 1.85Z"
        style={{
          fill: "#263238",
          transformOrigin: "259.925px 311.044px",
        }}
        className="animable"
      />
      <path
        d="M260 293.52s-.24.32-.74.83-1.24 1.23-2.18 2.1c-1.87 1.74-4.52 4.08-7.56 6.52s-5.9 4.51-8 6c-1 .72-1.92 1.29-2.52 1.66a4.87 4.87 0 0 1-1 .55 4.44 4.44 0 0 1 .85-.71l2.43-1.8c2-1.52 4.86-3.64 7.9-6.07s5.71-4.71 7.64-6.38l2.28-2a4.57 4.57 0 0 1 .9-.7Z"
        style={{
          fill: "#263238",
          transformOrigin: "249px 302.35px",
        }}
        className="animable"
      />
      <path
        d="M212.72 281.86c.05.15-1.44.78-3.09 1.87s-2.84 2.19-2.95 2.08a10.29 10.29 0 0 1 6-3.95Z"
        style={{
          fill: "#263238",
          transformOrigin: "209.701px 283.839px",
        }}
        className="animable"
      />
      <path
        d="M252.75 336.54a2.92 2.92 0 0 1-.9.29 17.07 17.07 0 0 1-2.52.44 22.93 22.93 0 0 1-3.8.1 24.2 24.2 0 0 1-9-2.25 22.78 22.78 0 0 1-3.31-1.89 17.83 17.83 0 0 1-2-1.57c-.45-.41-.68-.65-.65-.68s1.06.81 2.87 1.95a27.22 27.22 0 0 0 7.62 3.24 26.64 26.64 0 0 0 8.25.73c2.12-.15 3.42-.45 3.44-.36Z"
        style={{
          fill: "#fafafa",
          transformOrigin: "241.659px 334.193px",
        }}
        className="animable"
      />
      <path
        d="M255.53 351.58a5.21 5.21 0 0 1-1.84.33 16.13 16.13 0 0 1-4.51-.3 16.49 16.49 0 0 1-4.28-1.49 4.85 4.85 0 0 1-1.56-1 36.47 36.47 0 0 0 5.94 2 39.18 39.18 0 0 0 6.25.46Z"
        style={{
          fill: "#fafafa",
          transformOrigin: "249.435px 350.537px",
        }}
        className="animable"
      />
      <path
        d="M276.79 342.24a3 3 0 0 1-.76.45 23.72 23.72 0 0 1-2.21 1 33.75 33.75 0 0 1-15.71 2.17 22 22 0 0 1-2.39-.36 2.69 2.69 0 0 1-.86-.23c0-.09 1.26.1 3.28.22a39.78 39.78 0 0 0 15.55-2.15c1.91-.66 3.06-1.18 3.1-1.1Z"
        style={{
          fill: "#fafafa",
          transformOrigin: "265.825px 344.13px",
        }}
        className="animable"
      />
      <path
        d="M273 325.49c0 .08-1.28-.16-3.32-.4a52.33 52.33 0 0 0-8-.34 53.79 53.79 0 0 0-8 .91c-2 .39-3.25.72-3.28.64a3 3 0 0 1 .84-.34c.55-.19 1.36-.41 2.36-.66a42.66 42.66 0 0 1 8-1.07 41.81 41.81 0 0 1 8.07.49c1 .17 1.85.34 2.41.49a2.75 2.75 0 0 1 .92.28Z"
        style={{
          fill: "#fafafa",
          transformOrigin: "261.7px 325.257px",
        }}
        className="animable"
      />
      <path
        d="M281.47 372.28a4.33 4.33 0 0 1-1.17-.23 27.16 27.16 0 0 1-3.1-1 40.83 40.83 0 0 1-17.36-12.18 28.32 28.32 0 0 1-1.95-2.6 4.56 4.56 0 0 1-.62-1c.08-.05 1.05 1.34 2.85 3.37a45.36 45.36 0 0 0 17.21 12.09c2.53 1.02 4.16 1.46 4.14 1.55Z"
        style={{
          fill: "#fafafa",
          transformOrigin: "269.37px 363.774px",
        }}
        className="animable"
      />
      <path
        d="M244.6 371.76a11.48 11.48 0 0 1-.12-2.84 31.93 31.93 0 0 1 1-6.8 31.58 31.58 0 0 1 2.46-6.43 11.64 11.64 0 0 1 1.5-2.42 25.37 25.37 0 0 1-1.17 2.58 40.59 40.59 0 0 0-2.28 6.4 41.14 41.14 0 0 0-1.15 6.69 22.45 22.45 0 0 1-.24 2.82Z"
        style={{
          fill: "#fafafa",
          transformOrigin: "246.941px 362.515px",
        }}
        className="animable"
      />
      <path
        d="M219.85 360.51a8 8 0 0 1 0-2.39 13.62 13.62 0 0 1 1.78-5.52 17.88 17.88 0 0 1 3.86-4.31 9.15 9.15 0 0 1 1.94-1.39 13.36 13.36 0 0 1-1.69 1.67 21.35 21.35 0 0 0-3.66 4.3 15.28 15.28 0 0 0-1.86 5.3 14.79 14.79 0 0 1-.37 2.34Z"
        style={{
          fill: "#fafafa",
          transformOrigin: "223.595px 353.705px",
        }}
        className="animable"
      />
      <path
        d="M301.8 371.51a16.45 16.45 0 0 1-2.89 1.28 54.78 54.78 0 0 1-7.31 2.21 30.9 30.9 0 0 1-7.59.82 12.65 12.65 0 0 1-1.32-.08 8.82 8.82 0 0 1-1-.14 2.72 2.72 0 0 1-.83-.22c0-.09 1.21.11 3.14.08a38.1 38.1 0 0 0 7.47-1c2.89-.64 5.45-1.43 7.3-2a24.71 24.71 0 0 1 3.03-.95Z"
        style={{
          fill: "#fafafa",
          transformOrigin: "291.33px 373.667px",
        }}
        className="animable"
      />
      <path
        d="M290.82 351.74c.05 0-.26.64-1.1 1.25a15 15 0 0 1-3.53 1.86 21.76 21.76 0 0 1-3.82 1.12 6.23 6.23 0 0 1-1.21.13c-.29 0-.47-.11-.44-.12s.59-.08 1.57-.37 2.28-.7 3.71-1.25a22.48 22.48 0 0 0 3.51-1.67c.85-.51 1.23-.99 1.31-.95Z"
        style={{
          fill: "#fafafa",
          transformOrigin: "285.771px 353.919px",
        }}
        className="animable"
      />
      <path
        d="M283.94 331.66s0 .18-.15.36a3.18 3.18 0 0 1-.8.65 15.69 15.69 0 0 1-3 1.41 16.76 16.76 0 0 1-3.22.87c-.85.15-1.41 0-1.39 0s.51-.09 1.32-.32 1.91-.56 3.11-1a30.49 30.49 0 0 0 3-1.24 5.24 5.24 0 0 0 .84-.47c.19-.16.25-.27.29-.26Z"
        style={{
          fill: "#fafafa",
          transformOrigin: "279.66px 333.338px",
        }}
        className="animable"
      />
      <path
        d="M248.29 321.05a8.06 8.06 0 0 1-2.35.1 30.8 30.8 0 0 1-5.63-.79 30.09 30.09 0 0 1-5.38-1.82 8.49 8.49 0 0 1-2.06-1.14c.07-.15 3.28 1.46 7.56 2.46s7.86 1.03 7.86 1.19Z"
        style={{
          fill: "#fafafa",
          transformOrigin: "240.58px 319.292px",
        }}
        className="animable"
      />
      <path
        d="M277.08 312c.1.14-1.34 1.12-3.28 1.89s-3.64 1.12-3.67.94 1.56-.63 3.47-1.42 3.4-1.49 3.48-1.41Z"
        style={{
          fill: "#fafafa",
          transformOrigin: "273.607px 313.435px",
        }}
        className="animable"
      />
      <path
        d="M254.66 299a4.23 4.23 0 0 1 1.39 1.1 12.63 12.63 0 0 1 3.51 7.7 4.4 4.4 0 0 1-.08 1.77 17.15 17.15 0 0 0-4.82-10.57Z"
        style={{
          fill: "#fafafa",
          transformOrigin: "257.137px 304.285px",
        }}
        className="animable"
      />
      <path
        d="M223.15 313.23a3.76 3.76 0 0 1-.46-.94 16.32 16.32 0 0 1-.79-2.75 24.66 24.66 0 0 1 .07-9.39 49.66 49.66 0 0 1 2.72-9c.44-1.12.82-2 1.09-2.63a4 4 0 0 1 .48-.93 4.28 4.28 0 0 1-.29 1c-.26.74-.57 1.63-.94 2.67a61.77 61.77 0 0 0-2.55 9 27 27 0 0 0-.22 9.24c.39 2.33.98 3.7.89 3.73Z"
        style={{
          fill: "#fafafa",
          transformOrigin: "223.872px 300.41px",
        }}
        className="animable"
      />
      <path
        d="M199.64 303.61a3.28 3.28 0 0 1 .17-1 23.88 23.88 0 0 1 .79-2.68A34.23 34.23 0 0 1 211 285a24.69 24.69 0 0 1 2.24-1.67 3.71 3.71 0 0 1 .88-.51c.05.08-1.13.91-2.88 2.46a38.52 38.52 0 0 0-10.31 14.79c-.84 2.16-1.21 3.57-1.29 3.54Z"
        style={{
          fill: "#fafafa",
          transformOrigin: "206.881px 293.215px",
        }}
        className="animable"
      />
      <path
        d="M203.42 268.49c0 .09-1.14.14-2.9.64A27.65 27.65 0 0 0 194 272a31.15 31.15 0 0 0-5.64 4.36c-1.3 1.29-2 2.22-2 2.17s.11-.27.39-.7a8 8 0 0 1 .56-.77 12.19 12.19 0 0 1 .81-.95 26.2 26.2 0 0 1 5.64-4.55 23.37 23.37 0 0 1 6.68-2.81 9.76 9.76 0 0 1 1.24-.23 5.89 5.89 0 0 1 .94-.09 2.15 2.15 0 0 1 .8.06Z"
        style={{
          fill: "#fafafa",
          transformOrigin: "194.89px 273.474px",
        }}
        className="animable"
      />
      <path
        d="M194.09 254.85a31.39 31.39 0 0 0-8.6.66 30.73 30.73 0 0 0-7.87 3.51 8.17 8.17 0 0 1 2-1.58 20.17 20.17 0 0 1 5.73-2.43 19.86 19.86 0 0 1 6.18-.58 8.66 8.66 0 0 1 2.56.42Z"
        style={{
          fill: "#fafafa",
          transformOrigin: "185.855px 256.705px",
        }}
        className="animable"
      />
      <path
        d="M248.81 321a3.21 3.21 0 0 1 .21.66c.12.47.29 1.11.49 1.9l1.78 7.14c1.49 6.13 3.55 14.66 5.92 24.45l.1.42-.41-.12-10.48-2.95-30.62-8.7.22-.08-5.2 9-1.44 2.44-.39.63a1.16 1.16 0 0 1-.14.2s0-.08.1-.23l.33-.65 1.36-2.49c1.21-2.19 2.93-5.29 5.05-9.1l.07-.13h.15l30.65 8.61 10.44 3-.31.3c-2.3-9.8-4.3-18.35-5.74-24.49-.69-3-1.24-5.44-1.64-7.16l-.41-1.93a5.16 5.16 0 0 1-.09-.72Z"
        style={{
          fill: "#263238",
          transformOrigin: "233.08px 338.495px",
        }}
        className="animable"
      />
      <path
        d="M271.34 318.92a2.1 2.1 0 0 1 .2.58c.13.45.28 1 .48 1.71.41 1.55 1 3.69 1.65 6.3 1.37 5.4 3.22 12.74 5.28 20.85 1 4.07 2 7.94 2.82 11.5a27 27 0 0 1 .78 9.65 13.54 13.54 0 0 1-2.29 6.1 7.24 7.24 0 0 1-1.64 1.75 20.38 20.38 0 0 0 1.47-1.86 14 14 0 0 0 2.1-6 27.19 27.19 0 0 0-.89-9.5c-.88-3.53-1.84-7.41-2.86-11.48-2-8.12-3.8-15.48-5.12-20.88l-1.5-6.34c-.15-.71-.28-1.28-.38-1.73a4 4 0 0 1-.1-.65Z"
        style={{
          fill: "#263238",
          transformOrigin: "277.012px 348.14px",
        }}
        className="animable"
      />
      <g
        style={{
          opacity: 0.3,
          transformOrigin: "281.69px 354.39px",
        }}
        className="animable"
      >
        <path
          d="M278.8 377.74c6 .56 9.51-2.88 10.16-7.57.35-2.59-.5-5.17-1.34-7.65-3.69-10.81-7.43-21.72-13.28-31.54 2.21 9.82 5 19.25 7.24 29.08a30.28 30.28 0 0 1 .94 8.36 15 15 0 0 1-3.72 9.32"
          className="animable"
          style={{
            transformOrigin: "281.69px 354.39px",
          }}
        />
      </g>
      <path
        d="M256.65 289.15a12.25 12.25 0 0 0 15.56-9.3 7.18 7.18 0 0 0 6.21 1.65 11.85 11.85 0 0 0 5.78-3.12 14.42 14.42 0 0 0 4.86-10.86 10.59 10.59 0 0 0-6.57-9.52c-3.85-1.38-8.72.42-10.31 4.19-.72-2.14 1.12-5 .68-7.25-.88-4.45-3.54-7.05-5.79-7.14"
        style={{
          fill: "#263238",
          transformOrigin: "272.855px 268.738px",
        }}
        className="animable"
      />
      <path
        d="M261.49 288c4.41-7.68 5.67-17.9 6.78-26.75.53-4.17 1.45-10.1-1.39-12.7-3-2.79-3.33-7.09-6.83-9.25s-8.23-2.33-11.53.14"
        style={{
          fill: "#263238",
          transformOrigin: "258.683px 262.817px",
        }}
        className="animable"
      />
      <path
        d="M238.6 303.28v-12S226.05 289 225.31 279s-.48-33.28-.48-33.28a33.05 33.05 0 0 1 34.33 2.18l-.5 35.4v11.53l-10.27 8.34-9.81 7.72Z"
        style={{
          fill: "#ffbe9d",
          transformOrigin: "241.973px 276.408px",
        }}
        className="animable"
      />
      <path
        d="M235 266.65c1.68-2.15 4.41-3 6.66-1.52a6 6 0 0 1 1.91 7.31 7.53 7.53 0 0 1-4.78 3.74s4.52 8.24 7.4 10.43c3.42 2.6 5 3.88 9.25 4.38s3.66.54 6.06-3a13.78 13.78 0 0 0 2.35-8.17q.2-11.13.38-22.25a32.75 32.75 0 0 0-.51-8 10.74 10.74 0 0 0-4.1-6.59c-2.38-1.6-5.38-1.73-8.08-2.63-3.38-1.11-6.26-3.41-9.42-5.07s-7-2.64-10.21-1c-2.27 1.18-3.79 3.53-6 4.84-3.14 1.86-7.44 1.45-9 6.24a8.34 8.34 0 0 0 .06 5.11c2.16 6.5 10 9.1 15.6 6.27.11 1.1-.94 3.56.2 7 .36 1.11.49 2.81 2.18 2.83"
        style={{
          fill: "#263238",
          transformOrigin: "240.413px 262.335px",
        }}
        className="animable"
      />
      <path
        d="M236.75 272.93s0 .19.14.43a1.43 1.43 0 0 0 1.09.56 2.73 2.73 0 0 0 2.51-2.79 2.9 2.9 0 0 0-.72-2.12 2.86 2.86 0 0 0-1.53-.91c-1-.21-1.58.17-1.54.24s.6 0 1.41.25a2.53 2.53 0 0 1 1.69 2.51 2.33 2.33 0 0 1-1.83 2.31c-.81.05-1.15-.55-1.22-.48Z"
        style={{
          fill: "#eb996e",
          transformOrigin: "238.597px 270.979px",
        }}
        className="animable"
      />
      <path
        d="M287.75 267.64a3.68 3.68 0 0 1-.29.95 10.53 10.53 0 0 1-1.34 2.34 11.69 11.69 0 0 1-7.46 4.58 11.48 11.48 0 0 1-8.48-2.19 10.63 10.63 0 0 1-1.94-1.87 3.31 3.31 0 0 1-.54-.83 20.79 20.79 0 0 0 2.69 2.4 11.62 11.62 0 0 0 8.19 2 11.81 11.81 0 0 0 7.25-4.29 21.55 21.55 0 0 0 1.92-3.09Z"
        style={{
          fill: "#455a64",
          transformOrigin: "277.725px 271.63px",
        }}
        className="animable"
      />
      <path
        d="M286.36 266a3 3 0 0 1-.35.77 11.34 11.34 0 0 1-1.36 1.87 12.53 12.53 0 0 1-6.5 3.88 12.28 12.28 0 0 1-7.53-.71 10.68 10.68 0 0 1-2-1.14 2.54 2.54 0 0 1-.64-.55c.06-.09 1 .66 2.79 1.35a12.78 12.78 0 0 0 7.23.53 13.14 13.14 0 0 0 6.35-3.62c1.36-1.38 1.92-2.38 2.01-2.38Z"
        style={{
          fill: "#455a64",
          transformOrigin: "277.17px 269.407px",
        }}
        className="animable"
      />
      <path
        d="M269.53 278.94s-.14.1-.42.23a4.53 4.53 0 0 1-1.32.35 7.17 7.17 0 0 1-4.79-1.32 13.87 13.87 0 0 1-4.51-5.86c-1.22-2.5-2.19-5.44-4.09-8a9.4 9.4 0 0 0-3.43-2.93 12 12 0 0 0-4.11-1.08c-2.73-.28-5.25-.1-7.36-.39a11.79 11.79 0 0 1-4.77-1.49 7.37 7.37 0 0 1-1.09-.82 2 2 0 0 1-.32-.35s.5.43 1.51 1a12.41 12.41 0 0 0 4.71 1.29c2.07.24 4.57 0 7.37.28a12.31 12.31 0 0 1 4.28 1.1 10.07 10.07 0 0 1 3.63 3.07c2 2.63 2.92 5.6 4.1 8.08a13.87 13.87 0 0 0 4.29 5.77 7.18 7.18 0 0 0 4.56 1.42 8.08 8.08 0 0 0 1.76-.35Z"
        style={{
          fill: "#455a64",
          transformOrigin: "251.425px 268.413px",
        }}
        className="animable"
      />
      <path
        d="M268.55 275.31a1.22 1.22 0 0 1-.45.05 5.11 5.11 0 0 1-1.29-.16 8.2 8.2 0 0 1-3.9-2.65 15.19 15.19 0 0 1-1.88-2.69c-.58-1-1.1-2.17-1.68-3.35a23.37 23.37 0 0 0-2.05-3.51 10.16 10.16 0 0 0-1.43-1.58 6.85 6.85 0 0 0-.86-.64 4.75 4.75 0 0 0-.94-.58 11.81 11.81 0 0 0-4.13-1.21 31.7 31.7 0 0 0-4.08-.21 56.59 56.59 0 0 1-7-.19 12.46 12.46 0 0 1-4.53-1.35 8.71 8.71 0 0 1-1.07-.72 1.52 1.52 0 0 1-.34-.29s.53.32 1.5.83a13.43 13.43 0 0 0 4.48 1.17 62.44 62.44 0 0 0 7 .07 33 33 0 0 1 4.15.18 12.29 12.29 0 0 1 4.31 1.26 5.19 5.19 0 0 1 1 .61 6.31 6.31 0 0 1 .92.69 10.49 10.49 0 0 1 1.49 1.65 23 23 0 0 1 2.07 3.61c.57 1.19 1.08 2.33 1.63 3.35a15.2 15.2 0 0 0 1.78 2.66 8.14 8.14 0 0 0 3.68 2.69 10.07 10.07 0 0 0 1.62.31Z"
        style={{
          fill: "#455a64",
          transformOrigin: "250.735px 265.797px",
        }}
        className="animable"
      />
      <path
        d="M271 280.45s-.23-.13-.56-.47a10.45 10.45 0 0 1-1.21-1.54 12.46 12.46 0 0 1-1.94-6.17 12.3 12.3 0 0 1 1.45-6.3 9.6 9.6 0 0 1 1.08-1.65c.3-.35.49-.53.52-.5s-.58.84-1.28 2.31a13.06 13.06 0 0 0 .48 12.11c.79 1.41 1.51 2.15 1.46 2.21Z"
        style={{
          fill: "#f6a293",
          transformOrigin: "269.141px 272.133px",
        }}
        className="animable"
      />
    </AnimateCharacter>
    <g
      className="animable"
      style={{
        transformOrigin: "405.01px 414.687px",
      }}
    >
      <AnimateLeaf
        d="M410.14 418.9c6.9 2.41 15.9.25 21.8-4.06s10.15-10.48 13.91-16.74c1.61-2.68 3.18-5.46 3.68-8.54s-.24-6.54-2.62-8.55c-3.71-3.12-9.39-1.53-13.6.87a46.89 46.89 0 0 0-23.17 37"
        style={{
          fill: "#344f79",
          transformOrigin: "429.909px 399.59px",
        }}
        className="animable"
      />
      <AnimateLeaf
        d="M417.55 435.41c4.14 5.47 11.26 7.9 18.11 8.22s13.62-1.58 20-4c2.33-.89 4.87-2.11 5.67-4.47a5.68 5.68 0 0 0-1.22-5.27 11.66 11.66 0 0 0-4.62-3.15 31.56 31.56 0 0 0-20.16-1.09c-6.63 1.71-12.42 5.56-17.8 9.8"
        style={{
          fill: "#344f79",
          opacity:0.3,
          transformOrigin: "439.532px 434.079px",
        }}
        className="animable"
      />
      <AnimateLeaf
        d="M410 389.34c5.71.12 10-4.89 12.62-10a37 37 0 0 0 3.4-23.07c-.52-2.92-1.63-6.06-4.24-7.47s-6.11-.48-8.33 1.55-3.45 4.93-4.33 7.81c-3.07 9.92-2.41 21.31.88 31.16"
        style={{
          fill: "#344f79",
          opacity:0.7,
          transformOrigin: "416.86px 368.733px",
        }}
        className="animable"
      />
      <AnimateLeaf
        d="M391.28 420.93c9.74-16.57 11.36-36.85 5.61-55.19-.94-3-2.7-6.38-5.81-6.57-3.44-.22-5.6 3.62-6.55 6.94-3.34 11.64-2.63 24-1.9 36.11.46 7.45 3 13.81 8.65 18.71"
        style={{
          fill: "#344f79",
          opacity:0.5,
          transformOrigin: "391.115px 390.045px",
        }}
        className="animable"
      />
      <AnimateLeaf
        d="M381.15 427.75a39.82 39.82 0 0 0-23.62-25.06c-2.59-1-5.88-1.53-7.81.45s-1.31 5.18-.09 7.61c2 3.91 5.14 7.06 8.31 10.07 2.89 2.75 5.88 5.5 9.53 7.1s10.35 2 13.68-.17"
        style={{
          fill: "#344f79",
          transformOrigin: "364.818px 415.524px",
        }}
        className="animable"
      />
      <path
        d="M441.52 385.17s0 .06-.17.15l-.52.41-2 1.53-1.48 1.09c-.54.41-1.09.89-1.7 1.38-1.21 1-2.63 2.09-4.06 3.46l-2.3 2.08c-.79.73-1.56 1.55-2.39 2.37-1.67 1.61-3.29 3.49-5 5.43a107.36 107.36 0 0 0-17.8 28.8c-.95 2.43-1.91 4.72-2.6 6.94-.36 1.1-.76 2.16-1.06 3.19s-.57 2-.84 3c-.57 1.89-.91 3.65-1.27 5.18-.17.76-.35 1.47-.48 2.13s-.22 1.27-.31 1.82c-.19 1.06-.34 1.9-.45 2.5-.06.27-.1.48-.13.66l-.06.22a.59.59 0 0 1 0-.23c0-.18.05-.39.08-.66.09-.61.22-1.46.37-2.52.09-.55.18-1.16.28-1.83s.28-1.37.44-2.15c.34-1.53.65-3.3 1.21-5.2.26-1 .53-2 .82-3s.67-2.1 1-3.21c.68-2.23 1.62-4.54 2.57-7a105 105 0 0 1 17.87-28.9c1.76-1.94 3.4-3.82 5.1-5.43.83-.81 1.6-1.63 2.41-2.36l2.32-2.07c1.45-1.35 2.9-2.42 4.12-3.41.62-.49 1.18-.95 1.72-1.36l1.51-1.06c.89-.62 1.59-1.1 2.09-1.46l.56-.37c.08-.09.15-.13.15-.12Z"
        style={{
          fill: "#263238",
          transformOrigin: "419.204px 421.339px",
        }}
        className="animable"
      />
      <path
        d="M454.42 431.11a3.89 3.89 0 0 1-.67-.11c-.44-.08-1.07-.25-1.9-.39a54.57 54.57 0 0 0-7.05-.86 51.46 51.46 0 0 0-41.8 17.38 53.39 53.39 0 0 0-4.35 5.61c-.49.68-.81 1.25-1.07 1.61a3.27 3.27 0 0 1-.39.56 4.59 4.59 0 0 1 .31-.6c.23-.38.53-1 1-1.67a47.22 47.22 0 0 1 4.26-5.72 50.6 50.6 0 0 1 42-17.49 47.4 47.4 0 0 1 7.07 1c.82.16 1.45.36 1.88.47a2.94 2.94 0 0 1 .71.21Z"
        style={{
          fill: "#263238",
          transformOrigin: "425.805px 442.105px",
        }}
        className="animable"
      />
      <path
        d="M418.46 355.44v.26c0 .17-.09.43-.16.74-.15.68-.36 1.64-.64 2.85-.56 2.48-1.41 6-2.49 10.46-2.14 8.82-5.26 21-8.51 34.43-1.61 6.74-3.07 13.17-4.33 19s-2.29 11.17-3.07 15.64c-.43 2.23-.74 4.25-1 6s-.54 3.31-.73 4.57l-.45 2.89-.12.74-.06.26a.74.74 0 0 1 0-.26c0-.2.05-.45.08-.76.09-.69.21-1.66.37-2.9s.36-2.8.65-4.58.57-3.81 1-6.05c.74-4.48 1.76-9.79 3-15.67s2.69-12.32 4.3-19.05c3.25-13.47 6.42-25.61 8.65-34.41 1.1-4.37 2-7.92 2.63-10.42.31-1.2.55-2.15.72-2.83.09-.3.15-.54.2-.73a.9.9 0 0 1-.04-.18Z"
        style={{
          fill: "#263238",
          transformOrigin: "407.694px 404.36px",
        }}
        className="animable"
      />
      <path
        d="M396.1 452a.8.8 0 0 1-.07-.21c0-.16-.08-.35-.13-.59l-.48-2.31c-.41-2-1-4.91-1.58-8.52-1.25-7.21-2.73-17.22-3.64-28.36-.44-5.57-.69-10.89-.8-15.73s0-9.2.12-12.86c0-1.82.16-3.48.24-4.93s.18-2.7.27-3.72.16-1.77.22-2.34c0-.25.05-.45.07-.61a1.15 1.15 0 0 1 0-.21.67.67 0 0 1 0 .21v.61c0 .58-.08 1.36-.13 2.36s-.14 2.26-.19 3.72-.16 3.1-.18 4.92c-.11 3.66-.12 8 0 12.84s.38 10.14.82 15.7c.91 11.12 2.34 21.13 3.51 28.35.58 3.61 1.08 6.52 1.44 8.54.16 1 .29 1.75.39 2.32 0 .24.07.44.09.61a1.42 1.42 0 0 1 .03.21Z"
        style={{
          fill: "#263238",
          transformOrigin: "392.727px 411.805px",
        }}
        className="animable"
      />
      <path
        d="M396.82 454.12a2.57 2.57 0 0 1-.26-.57c-.16-.43-.37-1-.64-1.67l-.46-1.2-.62-1.41-.71-1.61c-.26-.57-.58-1.14-.89-1.76l-1-1.93-1.18-2c-.78-1.43-1.79-2.85-2.77-4.39a105.65 105.65 0 0 0-7.33-9.38 115.18 115.18 0 0 0-8.42-8.42c-1.4-1.18-2.68-2.36-4-3.35l-1.85-1.47-1.69-1.33c-1.1-.84-2.14-1.54-3.05-2.15s-1.7-1.15-2.37-1.55l-1.5-1a3 3 0 0 1-.52-.36 4.49 4.49 0 0 1 .56.28l1.56.89c.68.37 1.49.88 2.41 1.48s2 1.28 3.1 2.11l1.78 1.27 1.86 1.45c1.31 1 2.61 2.16 4 3.33a108.45 108.45 0 0 1 8.48 8.44 98.4 98.4 0 0 1 7.34 9.44c1 1.56 2 3 2.75 4.44l1.17 2.06c.33.68.66 1.33 1 2s.62 1.2.86 1.78.47 1.12.69 1.63.4 1 .59 1.43l.42 1.22.56 1.7a4.64 4.64 0 0 1 .13.6Z"
        style={{
          fill: "#263238",
          transformOrigin: "377.19px 431.345px",
        }}
        className="animable"
      />
      <path
        d="M437.91 404.39c0 .07-1.18.08-3.08.18a54.89 54.89 0 0 0-14.51 2.76c-1.8.59-2.9 1-2.93 1a3 3 0 0 1 .73-.4c.49-.23 1.2-.53 2.09-.87a44.29 44.29 0 0 1 7.19-2 43.84 43.84 0 0 1 7.42-.76h2.26a3.29 3.29 0 0 1 .83.09Z"
        style={{
          fill: "#263238",
          transformOrigin: "427.65px 406.315px",
        }}
        className="animable"
      />
      <path
        d="M445.26 440.27a22.33 22.33 0 0 0-9.74-10.49 6.82 6.82 0 0 1 2 .87 17.42 17.42 0 0 1 7 7.58 6.9 6.9 0 0 1 .74 2.04Z"
        style={{
          fill: "#263238",
          transformOrigin: "440.39px 435.025px",
        }}
        className="animable"
      />
      <path
        d="M420.21 368.89c.09.1-1.7 1.88-3.66 4.29s-3.35 4.51-3.46 4.44a27.31 27.31 0 0 1 7.12-8.73Z"
        style={{
          fill: "#263238",
          transformOrigin: "416.652px 373.256px",
        }}
        className="animable"
      />
      <path
        d="M414.32 358.73a16.41 16.41 0 0 1 .89 3.85 17.23 17.23 0 0 1 .44 3.92 16.41 16.41 0 0 1-.89-3.85 17.28 17.28 0 0 1-.44-3.92Z"
        style={{
          fill: "#263238",
          transformOrigin: "414.985px 362.615px",
        }}
        className="animable"
      />
      <path
        d="M396.11 390.61a47.52 47.52 0 0 1-2.85 6 48.44 48.44 0 0 1-3.26 5.79 48.27 48.27 0 0 1 2.85-6 50.5 50.5 0 0 1 3.26-5.79Z"
        style={{
          fill: "#263238",
          transformOrigin: "393.055px 396.505px",
        }}
        className="animable"
      />
      <path
        d="M385.27 379.79a27.53 27.53 0 0 1 2.41 4.34 27.94 27.94 0 0 1 2 4.54 25.68 25.68 0 0 1-2.42-4.34 26 26 0 0 1-1.99-4.54Z"
        style={{
          fill: "#263238",
          transformOrigin: "387.475px 384.23px",
        }}
        className="animable"
      />
      <path
        d="M369.33 416.81c0 .13-2-.25-4.37-.41s-4.38-.08-4.39-.21a17.45 17.45 0 0 1 8.76.62Z"
        style={{
          fill: "#263238",
          transformOrigin: "364.95px 416.366px",
        }}
        className="animable"
      />
      <path
        d="m380.22 449.53 5.42 28.47a4 4 0 0 0 3.92 3.25h16a4 4 0 0 0 3.94-3.34l4.71-28.42Z"
        style={{
          fill: "#263238",
          transformOrigin: "397.215px 465.37px",
        }}
        className="animable"
      />
      <path
        style={{
          fill: "#455a64",
          transformOrigin: "397.22px 454.165px",
        }}
        className="animable"
        d="M381.98 458.8h30.62l1.63-9.27h-34.02l1.77 9.27z"
      />
      <path
        style={{
          fill: "#fafafa",
          transformOrigin: "397.29px 460.49px",
        }}
        className="animable"
        d="m381.98 458.8.64 3.38h29.51l.47-3.38h-30.62z"
      />
    </g>
  </svg>
)

export default IconLoading2
